import { defineMessages } from 'react-intl';

/** ISO 3166-2 subdivision display names keyed by code with underscores (e.g. AU_NSW). */
export const jurisdictionMessages = defineMessages({
  AU_ACT: {
    defaultMessage: 'Australian Capital Territory',
    id: 'x7zuMWFN2i',
    description: 'Jurisdiction subdivision name for AU_ACT',
  },
  AU_NSW: {
    defaultMessage: 'New South Wales',
    id: 'cZZL2UdIYO',
    description: 'Jurisdiction subdivision name for AU_NSW',
  },
  AU_NT: {
    defaultMessage: 'Northern Territory',
    id: 'sSuMBveO0A',
    description: 'Jurisdiction subdivision name for AU_NT',
  },
  AU_QLD: {
    defaultMessage: 'Queensland',
    id: 'vF4RQ+5giF',
    description: 'Jurisdiction subdivision name for AU_QLD',
  },
  AU_SA: {
    defaultMessage: 'South Australia',
    id: '7JkRpDsOax',
    description: 'Jurisdiction subdivision name for AU_SA',
  },
  AU_TAS: {
    defaultMessage: 'Tasmania',
    id: 'eUqEzgqosg',
    description: 'Jurisdiction subdivision name for AU_TAS',
  },
  AU_VIC: {
    defaultMessage: 'Victoria',
    id: '6sIvHL3keF',
    description: 'Jurisdiction subdivision name for AU_VIC',
  },
  AU_WA: {
    defaultMessage: 'Western Australia',
    id: 'Uz3vRj/Duu',
    description: 'Jurisdiction subdivision name for AU_WA',
  },
  DE_BB: {
    defaultMessage: 'Brandenburg',
    id: 'LbZ+jH+v8r',
    description: 'Jurisdiction subdivision name for DE_BB',
  },
  DE_BE: {
    defaultMessage: 'Berlin',
    id: 'WMb7tNrVqX',
    description: 'Jurisdiction subdivision name for DE_BE',
  },
  DE_BW: {
    defaultMessage: 'Baden-Württemberg',
    id: 'AAf98jy2gS',
    description: 'Jurisdiction subdivision name for DE_BW',
  },
  DE_BY: {
    defaultMessage: 'Bayern',
    id: '/jW5lAU5bc',
    description: 'Jurisdiction subdivision name for DE_BY',
  },
  DE_HB: {
    defaultMessage: 'Bremen',
    id: 'Ivqe3mPY5O',
    description: 'Jurisdiction subdivision name for DE_HB',
  },
  DE_HE: {
    defaultMessage: 'Hessen',
    id: 'RqoUla/39O',
    description: 'Jurisdiction subdivision name for DE_HE',
  },
  DE_HH: {
    defaultMessage: 'Hamburg',
    id: 'LXBZEtVfvS',
    description: 'Jurisdiction subdivision name for DE_HH',
  },
  DE_MV: {
    defaultMessage: 'Mecklenburg-Vorpommern',
    id: 'Yn22HuzSxG',
    description: 'Jurisdiction subdivision name for DE_MV',
  },
  DE_NI: {
    defaultMessage: 'Niedersachsen',
    id: 'deVK6EGnPr',
    description: 'Jurisdiction subdivision name for DE_NI',
  },
  DE_NW: {
    defaultMessage: 'Nordrhein-Westfalen',
    id: 'R5/khb6hWk',
    description: 'Jurisdiction subdivision name for DE_NW',
  },
  DE_RP: {
    defaultMessage: 'Rheinland-Pfalz',
    id: 'Hsd+4areMB',
    description: 'Jurisdiction subdivision name for DE_RP',
  },
  DE_SH: {
    defaultMessage: 'Schleswig-Holstein',
    id: '+kFE5CTNKb',
    description: 'Jurisdiction subdivision name for DE_SH',
  },
  DE_SL: {
    defaultMessage: 'Saarland',
    id: 'ef3ydS49dy',
    description: 'Jurisdiction subdivision name for DE_SL',
  },
  DE_SN: {
    defaultMessage: 'Sachsen',
    id: 'k0ohbRPvsr',
    description: 'Jurisdiction subdivision name for DE_SN',
  },
  DE_ST: {
    defaultMessage: 'Sachsen-Anhalt',
    id: '0xtRDGiNE0',
    description: 'Jurisdiction subdivision name for DE_ST',
  },
  DE_TH: {
    defaultMessage: 'Thüringen',
    id: 'c6YkasXfIE',
    description: 'Jurisdiction subdivision name for DE_TH',
  },
  FR_01: {
    defaultMessage: 'Ain',
    id: 'QKMbhPeidX',
    description: 'Jurisdiction subdivision name for FR_01',
  },
  FR_02: {
    defaultMessage: 'Aisne',
    id: '6GLz3tLUwC',
    description: 'Jurisdiction subdivision name for FR_02',
  },
  FR_03: {
    defaultMessage: 'Allier',
    id: 'WGJTlQPHOL',
    description: 'Jurisdiction subdivision name for FR_03',
  },
  FR_04: {
    defaultMessage: 'Alpes-de-Haute-Provence',
    id: 'XGOUMFbF4e',
    description: 'Jurisdiction subdivision name for FR_04',
  },
  FR_05: {
    defaultMessage: 'Hautes-Alpes',
    id: 'vgsjPEdhLk',
    description: 'Jurisdiction subdivision name for FR_05',
  },
  FR_06: {
    defaultMessage: 'Alpes-Maritimes',
    id: '9dUg3RNkS0',
    description: 'Jurisdiction subdivision name for FR_06',
  },
  FR_07: {
    defaultMessage: 'Ardèche',
    id: '6LA5UPjfcc',
    description: 'Jurisdiction subdivision name for FR_07',
  },
  FR_08: {
    defaultMessage: 'Ardennes',
    id: 'r14RrjrVYm',
    description: 'Jurisdiction subdivision name for FR_08',
  },
  FR_09: {
    defaultMessage: 'Ariège',
    id: 'g59qPbC0t+',
    description: 'Jurisdiction subdivision name for FR_09',
  },
  FR_10: {
    defaultMessage: 'Aube',
    id: '2BbSYs6Ror',
    description: 'Jurisdiction subdivision name for FR_10',
  },
  FR_11: {
    defaultMessage: 'Aude',
    id: 'lByr7M8ngA',
    description: 'Jurisdiction subdivision name for FR_11',
  },
  FR_12: {
    defaultMessage: 'Aveyron',
    id: 'WUnV0gvg/n',
    description: 'Jurisdiction subdivision name for FR_12',
  },
  FR_13: {
    defaultMessage: 'Bouches-du-Rhône',
    id: 'zlHyzrRrve',
    description: 'Jurisdiction subdivision name for FR_13',
  },
  FR_14: {
    defaultMessage: 'Calvados',
    id: 'aTXprVUvGb',
    description: 'Jurisdiction subdivision name for FR_14',
  },
  FR_15: {
    defaultMessage: 'Cantal',
    id: 'Btngs1CGlH',
    description: 'Jurisdiction subdivision name for FR_15',
  },
  FR_16: {
    defaultMessage: 'Charente',
    id: 'rMHyfnpeOp',
    description: 'Jurisdiction subdivision name for FR_16',
  },
  FR_17: {
    defaultMessage: 'Charente-Maritime',
    id: 'sqjSL46rVn',
    description: 'Jurisdiction subdivision name for FR_17',
  },
  FR_18: {
    defaultMessage: 'Cher',
    id: 'UxYwXue7af',
    description: 'Jurisdiction subdivision name for FR_18',
  },
  FR_19: {
    defaultMessage: 'Corrèze',
    id: 'j8iwjYljXg',
    description: 'Jurisdiction subdivision name for FR_19',
  },
  FR_21: {
    defaultMessage: "Côte-d'Or",
    id: 'i8yZjj16cd',
    description: 'Jurisdiction subdivision name for FR_21',
  },
  FR_22: {
    defaultMessage: "Côtes-d'Armor",
    id: 'wOxn9Ycy+n',
    description: 'Jurisdiction subdivision name for FR_22',
  },
  FR_23: {
    defaultMessage: 'Creuse',
    id: 'RK009Bv1uz',
    description: 'Jurisdiction subdivision name for FR_23',
  },
  FR_24: {
    defaultMessage: 'Dordogne',
    id: 'g6GmiVyMpL',
    description: 'Jurisdiction subdivision name for FR_24',
  },
  FR_25: {
    defaultMessage: 'Doubs',
    id: 'Y+YvXMO1Hn',
    description: 'Jurisdiction subdivision name for FR_25',
  },
  FR_26: {
    defaultMessage: 'Drôme',
    id: '8WCDhHAUpq',
    description: 'Jurisdiction subdivision name for FR_26',
  },
  FR_27: {
    defaultMessage: 'Eure',
    id: 'Meu5g0e2uT',
    description: 'Jurisdiction subdivision name for FR_27',
  },
  FR_28: {
    defaultMessage: 'Eure-et-Loir',
    id: '3Ue/rN6wHJ',
    description: 'Jurisdiction subdivision name for FR_28',
  },
  FR_29: {
    defaultMessage: 'Finistère',
    id: '9RH7nAKxh2',
    description: 'Jurisdiction subdivision name for FR_29',
  },
  FR_2A: {
    defaultMessage: 'Corse-du-Sud',
    id: 'LuTFOb5Cwo',
    description: 'Jurisdiction subdivision name for FR_2A',
  },
  FR_2B: {
    defaultMessage: 'Haute-Corse',
    id: 'P5Z774K19+',
    description: 'Jurisdiction subdivision name for FR_2B',
  },
  FR_30: {
    defaultMessage: 'Gard',
    id: 'PJvCZPpEAS',
    description: 'Jurisdiction subdivision name for FR_30',
  },
  FR_31: {
    defaultMessage: 'Haute-Garonne',
    id: '23XUlnsgQz',
    description: 'Jurisdiction subdivision name for FR_31',
  },
  FR_32: {
    defaultMessage: 'Gers',
    id: 'BVjJJAU1iy',
    description: 'Jurisdiction subdivision name for FR_32',
  },
  FR_33: {
    defaultMessage: 'Gironde',
    id: '7dfsjWNZER',
    description: 'Jurisdiction subdivision name for FR_33',
  },
  FR_34: {
    defaultMessage: 'Hérault',
    id: '5Q76FrrzNB',
    description: 'Jurisdiction subdivision name for FR_34',
  },
  FR_35: {
    defaultMessage: 'Ille-et-Vilaine',
    id: 'D5ZiSEBi+W',
    description: 'Jurisdiction subdivision name for FR_35',
  },
  FR_36: {
    defaultMessage: 'Indre',
    id: 'otgjqUtLH5',
    description: 'Jurisdiction subdivision name for FR_36',
  },
  FR_37: {
    defaultMessage: 'Indre-et-Loire',
    id: 'ofnpFNpp07',
    description: 'Jurisdiction subdivision name for FR_37',
  },
  FR_38: {
    defaultMessage: 'Isère',
    id: '3IAEvEuOm6',
    description: 'Jurisdiction subdivision name for FR_38',
  },
  FR_39: {
    defaultMessage: 'Jura',
    id: 'VCwqbq9YGU',
    description: 'Jurisdiction subdivision name for FR_39',
  },
  FR_40: {
    defaultMessage: 'Landes',
    id: 'Z+s5NObZcD',
    description: 'Jurisdiction subdivision name for FR_40',
  },
  FR_41: {
    defaultMessage: 'Loir-et-Cher',
    id: 'vKEPrI5+wN',
    description: 'Jurisdiction subdivision name for FR_41',
  },
  FR_42: {
    defaultMessage: 'Loire',
    id: 'doKmN6UYsN',
    description: 'Jurisdiction subdivision name for FR_42',
  },
  FR_43: {
    defaultMessage: 'Haute-Loire',
    id: 'KejFaQPsA5',
    description: 'Jurisdiction subdivision name for FR_43',
  },
  FR_44: {
    defaultMessage: 'Loire-Atlantique',
    id: 'WKkATFhx6+',
    description: 'Jurisdiction subdivision name for FR_44',
  },
  FR_45: {
    defaultMessage: 'Loiret',
    id: 'oUTRIshMGY',
    description: 'Jurisdiction subdivision name for FR_45',
  },
  FR_46: {
    defaultMessage: 'Lot',
    id: 'GBnkgQ9wb3',
    description: 'Jurisdiction subdivision name for FR_46',
  },
  FR_47: {
    defaultMessage: 'Lot-et-Garonne',
    id: 'HbH+7AtkA9',
    description: 'Jurisdiction subdivision name for FR_47',
  },
  FR_48: {
    defaultMessage: 'Lozère',
    id: 'kAiXdfNNMW',
    description: 'Jurisdiction subdivision name for FR_48',
  },
  FR_49: {
    defaultMessage: 'Maine-et-Loire',
    id: 'IlqGPg7m2l',
    description: 'Jurisdiction subdivision name for FR_49',
  },
  FR_50: {
    defaultMessage: 'Manche',
    id: 'uBduevwD2U',
    description: 'Jurisdiction subdivision name for FR_50',
  },
  FR_51: {
    defaultMessage: 'Marne',
    id: 'l8wwhKDlB8',
    description: 'Jurisdiction subdivision name for FR_51',
  },
  FR_52: {
    defaultMessage: 'Haute-Marne',
    id: 'dLT/x/QC1m',
    description: 'Jurisdiction subdivision name for FR_52',
  },
  FR_53: {
    defaultMessage: 'Mayenne',
    id: 'BOJQfQcEy4',
    description: 'Jurisdiction subdivision name for FR_53',
  },
  FR_54: {
    defaultMessage: 'Meurthe-et-Moselle',
    id: 'HvCfwLNbUb',
    description: 'Jurisdiction subdivision name for FR_54',
  },
  FR_55: {
    defaultMessage: 'Meuse',
    id: 'SacO/AKdpo',
    description: 'Jurisdiction subdivision name for FR_55',
  },
  FR_56: {
    defaultMessage: 'Morbihan',
    id: 'hpQ7R6xUPg',
    description: 'Jurisdiction subdivision name for FR_56',
  },
  FR_57: {
    defaultMessage: 'Moselle',
    id: 'vFfTEoun1x',
    description: 'Jurisdiction subdivision name for FR_57',
  },
  FR_58: {
    defaultMessage: 'Nièvre',
    id: 'r34c/jU2Y4',
    description: 'Jurisdiction subdivision name for FR_58',
  },
  FR_59: {
    defaultMessage: 'Nord',
    id: 'J/mAY3xEZO',
    description: 'Jurisdiction subdivision name for FR_59',
  },
  FR_60: {
    defaultMessage: 'Oise',
    id: 'QLfJws43sh',
    description: 'Jurisdiction subdivision name for FR_60',
  },
  FR_61: {
    defaultMessage: 'Orne',
    id: 'fypzZLP1i+',
    description: 'Jurisdiction subdivision name for FR_61',
  },
  FR_62: {
    defaultMessage: 'Pas-de-Calais',
    id: 'WTAr4Zxxiu',
    description: 'Jurisdiction subdivision name for FR_62',
  },
  FR_63: {
    defaultMessage: 'Puy-de-Dôme',
    id: 'v0lgLQpP96',
    description: 'Jurisdiction subdivision name for FR_63',
  },
  FR_64: {
    defaultMessage: 'Pyrénées-Atlantiques',
    id: 'jnnkfngdqK',
    description: 'Jurisdiction subdivision name for FR_64',
  },
  FR_65: {
    defaultMessage: 'Hautes-Pyrénées',
    id: 'AbCEzeJpy1',
    description: 'Jurisdiction subdivision name for FR_65',
  },
  FR_66: {
    defaultMessage: 'Pyrénées-Orientales',
    id: 'YlGiUvnIhx',
    description: 'Jurisdiction subdivision name for FR_66',
  },
  FR_67: {
    defaultMessage: 'Bas-Rhin',
    id: 'LoHhnhaL3L',
    description: 'Jurisdiction subdivision name for FR_67',
  },
  FR_68: {
    defaultMessage: 'Haut-Rhin',
    id: '3use8xfc51',
    description: 'Jurisdiction subdivision name for FR_68',
  },
  FR_69: {
    defaultMessage: 'Rhône',
    id: '4WMfy0A1CG',
    description: 'Jurisdiction subdivision name for FR_69',
  },
  FR_70: {
    defaultMessage: 'Haute-Saône',
    id: 'PEsvEpmi5B',
    description: 'Jurisdiction subdivision name for FR_70',
  },
  FR_71: {
    defaultMessage: 'Saône-et-Loire',
    id: 'oeK3BM+7iz',
    description: 'Jurisdiction subdivision name for FR_71',
  },
  FR_72: {
    defaultMessage: 'Sarthe',
    id: 'RrBUHOeXVI',
    description: 'Jurisdiction subdivision name for FR_72',
  },
  FR_73: {
    defaultMessage: 'Savoie',
    id: 'K2JOOLSNVw',
    description: 'Jurisdiction subdivision name for FR_73',
  },
  FR_74: {
    defaultMessage: 'Haute-Savoie',
    id: 'GIviNiFkzW',
    description: 'Jurisdiction subdivision name for FR_74',
  },
  FR_75: {
    defaultMessage: 'Paris',
    id: 'AaELeBchAz',
    description: 'Jurisdiction subdivision name for FR_75',
  },
  FR_76: {
    defaultMessage: 'Seine-Maritime',
    id: 'ONx8jImKOw',
    description: 'Jurisdiction subdivision name for FR_76',
  },
  FR_77: {
    defaultMessage: 'Seine-et-Marne',
    id: 'OwNVBr+50q',
    description: 'Jurisdiction subdivision name for FR_77',
  },
  FR_78: {
    defaultMessage: 'Yvelines',
    id: '3l5Ku0vWux',
    description: 'Jurisdiction subdivision name for FR_78',
  },
  FR_79: {
    defaultMessage: 'Deux-Sèvres',
    id: '9JYiFjawXt',
    description: 'Jurisdiction subdivision name for FR_79',
  },
  FR_80: {
    defaultMessage: 'Somme',
    id: 'P/YXfly0lD',
    description: 'Jurisdiction subdivision name for FR_80',
  },
  FR_81: {
    defaultMessage: 'Tarn',
    id: 'Nz1V7Un7HM',
    description: 'Jurisdiction subdivision name for FR_81',
  },
  FR_82: {
    defaultMessage: 'Tarn-et-Garonne',
    id: '/qpBihFmVZ',
    description: 'Jurisdiction subdivision name for FR_82',
  },
  FR_83: {
    defaultMessage: 'Var',
    id: 'APBFYXJtQy',
    description: 'Jurisdiction subdivision name for FR_83',
  },
  FR_84: {
    defaultMessage: 'Vaucluse',
    id: 'rVfXlCyn1K',
    description: 'Jurisdiction subdivision name for FR_84',
  },
  FR_85: {
    defaultMessage: 'Vendée',
    id: 'dx7IA3W6Vt',
    description: 'Jurisdiction subdivision name for FR_85',
  },
  FR_86: {
    defaultMessage: 'Vienne',
    id: 'EJN2tquhN/',
    description: 'Jurisdiction subdivision name for FR_86',
  },
  FR_87: {
    defaultMessage: 'Haute-Vienne',
    id: 'mkl1bTC6GC',
    description: 'Jurisdiction subdivision name for FR_87',
  },
  FR_88: {
    defaultMessage: 'Vosges',
    id: 'Qq2hmATchL',
    description: 'Jurisdiction subdivision name for FR_88',
  },
  FR_89: {
    defaultMessage: 'Yonne',
    id: 'DmpAlAg+Tf',
    description: 'Jurisdiction subdivision name for FR_89',
  },
  FR_90: {
    defaultMessage: 'Territoire de Belfort',
    id: '//fQKZsX1v',
    description: 'Jurisdiction subdivision name for FR_90',
  },
  FR_91: {
    defaultMessage: 'Essonne',
    id: 'oz87ljaLax',
    description: 'Jurisdiction subdivision name for FR_91',
  },
  FR_92: {
    defaultMessage: 'Hauts-de-Seine',
    id: 'SbDs0+RQhy',
    description: 'Jurisdiction subdivision name for FR_92',
  },
  FR_93: {
    defaultMessage: 'Seine-Saint-Denis',
    id: 'ShNcG0tZD3',
    description: 'Jurisdiction subdivision name for FR_93',
  },
  FR_94: {
    defaultMessage: 'Val-de-Marne',
    id: 'dhizFKesi5',
    description: 'Jurisdiction subdivision name for FR_94',
  },
  FR_95: {
    defaultMessage: "Val-d'Oise",
    id: '99rdwPoVlM',
    description: 'Jurisdiction subdivision name for FR_95',
  },
  FR_A: {
    defaultMessage: 'Alsace',
    id: 'sgIZv8pHjE',
    description: 'Jurisdiction subdivision name for FR_A',
  },
  FR_B: {
    defaultMessage: 'Aquitaine',
    id: 'obJ33R9Ch2',
    description: 'Jurisdiction subdivision name for FR_B',
  },
  FR_BL: {
    defaultMessage: 'Saint-Barthélemy',
    id: 'Ckkn6i/1Ja',
    description: 'Jurisdiction subdivision name for FR_BL',
  },
  FR_C: {
    defaultMessage: 'Auvergne',
    id: 'HqeOPEtbIx',
    description: 'Jurisdiction subdivision name for FR_C',
  },
  FR_CP: {
    defaultMessage: 'Clipperton',
    id: 'QlcjvmobSP',
    description: 'Jurisdiction subdivision name for FR_CP',
  },
  FR_D: {
    defaultMessage: 'Bourgogne',
    id: '9kYNiRtoWK',
    description: 'Jurisdiction subdivision name for FR_D',
  },
  FR_E: {
    defaultMessage: 'Bretagne',
    id: 'XEU7JbpjBe',
    description: 'Jurisdiction subdivision name for FR_E',
  },
  FR_F: {
    defaultMessage: 'Centre',
    id: 'i0AQsivGhd',
    description: 'Jurisdiction subdivision name for FR_F',
  },
  FR_G: {
    defaultMessage: 'Champagne-Ardenne',
    id: 'ZV/gKpmoEJ',
    description: 'Jurisdiction subdivision name for FR_G',
  },
  FR_GF: {
    defaultMessage: 'Guyane',
    id: '7eFe41w+Mw',
    description: 'Jurisdiction subdivision name for FR_GF',
  },
  FR_GP: {
    defaultMessage: 'Guadeloupe',
    id: 'P58g7UnI7q',
    description: 'Jurisdiction subdivision name for FR_GP',
  },
  FR_H: {
    defaultMessage: 'Corse',
    id: 'R/1sWWr9NC',
    description: 'Jurisdiction subdivision name for FR_H',
  },
  FR_I: {
    defaultMessage: 'Franche-Comté',
    id: 'WHS8zQMajG',
    description: 'Jurisdiction subdivision name for FR_I',
  },
  FR_J: {
    defaultMessage: 'Île-de-France',
    id: '94RM23RYTc',
    description: 'Jurisdiction subdivision name for FR_J',
  },
  FR_K: {
    defaultMessage: 'Languedoc-Roussillon',
    id: 'si+8y2B49u',
    description: 'Jurisdiction subdivision name for FR_K',
  },
  FR_L: {
    defaultMessage: 'Limousin',
    id: 'yJgVPor6Wi',
    description: 'Jurisdiction subdivision name for FR_L',
  },
  FR_M: {
    defaultMessage: 'Lorraine',
    id: 'n50bzuRPOh',
    description: 'Jurisdiction subdivision name for FR_M',
  },
  FR_MF: {
    defaultMessage: 'Saint-Martin',
    id: '+rLh2O9Fgl',
    description: 'Jurisdiction subdivision name for FR_MF',
  },
  FR_MQ: {
    defaultMessage: 'Martinique',
    id: 'mv8w5e4wog',
    description: 'Jurisdiction subdivision name for FR_MQ',
  },
  FR_N: {
    defaultMessage: 'Midi-Pyrénées',
    id: 'wu2/93vtpU',
    description: 'Jurisdiction subdivision name for FR_N',
  },
  FR_NC: {
    defaultMessage: 'Nouvelle-Calédonie',
    id: 'GRFan63EO/',
    description: 'Jurisdiction subdivision name for FR_NC',
  },
  FR_O: {
    defaultMessage: 'Nord-Pas-de-Calais',
    id: 'cCTkjaj8Gp',
    description: 'Jurisdiction subdivision name for FR_O',
  },
  FR_P: {
    defaultMessage: 'Basse-Normandie',
    id: '4I2RbJqA2w',
    description: 'Jurisdiction subdivision name for FR_P',
  },
  FR_PF: {
    defaultMessage: 'Polynésie française',
    id: '076h7M+wSw',
    description: 'Jurisdiction subdivision name for FR_PF',
  },
  FR_PM: {
    defaultMessage: 'Saint-Pierre-et-Miquelon',
    id: 'D36pjLyMkZ',
    description: 'Jurisdiction subdivision name for FR_PM',
  },
  FR_Q: {
    defaultMessage: 'Haute-Normandie',
    id: 'ocxT0WCJSL',
    description: 'Jurisdiction subdivision name for FR_Q',
  },
  FR_R: {
    defaultMessage: 'Pays-de-la-Loire',
    id: '7vsIDgZOX8',
    description: 'Jurisdiction subdivision name for FR_R',
  },
  FR_RE: {
    defaultMessage: 'La Réunion',
    id: '8wGOcb0/ly',
    description: 'Jurisdiction subdivision name for FR_RE',
  },
  FR_S: {
    defaultMessage: 'Picardie',
    id: '9ak4sm3DOL',
    description: 'Jurisdiction subdivision name for FR_S',
  },
  FR_T: {
    defaultMessage: 'Poitou-Charentes',
    id: 'TUnYRwZOmB',
    description: 'Jurisdiction subdivision name for FR_T',
  },
  FR_TF: {
    defaultMessage: 'Terres australes françaises',
    id: 'UZfSFo2XpG',
    description: 'Jurisdiction subdivision name for FR_TF',
  },
  FR_U: {
    defaultMessage: "Provence-Alpes-Côte-d'Azur",
    id: 'EgKH0iovUD',
    description: 'Jurisdiction subdivision name for FR_U',
  },
  FR_V: {
    defaultMessage: 'Rhône-Alpes',
    id: 'o8m9BP9ptH',
    description: 'Jurisdiction subdivision name for FR_V',
  },
  FR_WF: {
    defaultMessage: 'Wallis-et-Futuna',
    id: 'Tg1hUGHm2c',
    description: 'Jurisdiction subdivision name for FR_WF',
  },
  FR_YT: {
    defaultMessage: 'Mayotte',
    id: 'Ixsnn/7ah9',
    description: 'Jurisdiction subdivision name for FR_YT',
  },
  GB_ABD: {
    defaultMessage: 'Aberdeenshire',
    id: 'o2vwhvdPlO',
    description: 'Jurisdiction subdivision name for GB_ABD',
  },
  GB_ABE: {
    defaultMessage: 'Aberdeen City',
    id: 'sJcj8irBwv',
    description: 'Jurisdiction subdivision name for GB_ABE',
  },
  GB_AGB: {
    defaultMessage: 'Argyll and Bute',
    id: 'jBm64tFUwo',
    description: 'Jurisdiction subdivision name for GB_AGB',
  },
  GB_AGY: {
    defaultMessage: 'Isle of Anglesey',
    id: 'idFM1Nf1ob',
    description: 'Jurisdiction subdivision name for GB_AGY',
  },
  GB_ANS: {
    defaultMessage: 'Angus',
    id: '1ztfAb9uBG',
    description: 'Jurisdiction subdivision name for GB_ANS',
  },
  GB_ANT: {
    defaultMessage: 'Antrim',
    id: 'Gw0MQ26tw+',
    description: 'Jurisdiction subdivision name for GB_ANT',
  },
  GB_ARD: {
    defaultMessage: 'Ards',
    id: 'VeXVu/Bwee',
    description: 'Jurisdiction subdivision name for GB_ARD',
  },
  GB_ARM: {
    defaultMessage: 'Armagh',
    id: 'NE1Pc0HHjH',
    description: 'Jurisdiction subdivision name for GB_ARM',
  },
  GB_BAS: {
    defaultMessage: 'Bath and North East Somerset',
    id: 'jE/m7cSUyJ',
    description: 'Jurisdiction subdivision name for GB_BAS',
  },
  GB_BBD: {
    defaultMessage: 'Blackburn with Darwen',
    id: 'LylJXkELg4',
    description: 'Jurisdiction subdivision name for GB_BBD',
  },
  GB_BDF: {
    defaultMessage: 'Bedford',
    id: 'yoXib8bM+l',
    description: 'Jurisdiction subdivision name for GB_BDF',
  },
  GB_BDG: {
    defaultMessage: 'Barking and Dagenham',
    id: '0DDtXZFBAE',
    description: 'Jurisdiction subdivision name for GB_BDG',
  },
  GB_BEN: {
    defaultMessage: 'Brent',
    id: 'plR3fFTTN+',
    description: 'Jurisdiction subdivision name for GB_BEN',
  },
  GB_BEX: {
    defaultMessage: 'Bexley',
    id: 'Fg1vYrIP8i',
    description: 'Jurisdiction subdivision name for GB_BEX',
  },
  GB_BFS: {
    defaultMessage: 'Belfast',
    id: 'ylZ1ntkTSA',
    description: 'Jurisdiction subdivision name for GB_BFS',
  },
  GB_BGE: {
    defaultMessage: 'Bridgend',
    id: 'FnwjUcUNUp',
    description: 'Jurisdiction subdivision name for GB_BGE',
  },
  GB_BGW: {
    defaultMessage: 'Blaenau Gwent',
    id: 'q/xxUt5JOY',
    description: 'Jurisdiction subdivision name for GB_BGW',
  },
  GB_BIR: {
    defaultMessage: 'Birmingham',
    id: 'rEb85fzDLv',
    description: 'Jurisdiction subdivision name for GB_BIR',
  },
  GB_BKM: {
    defaultMessage: 'Buckinghamshire',
    id: 'GAgH5CnqHN',
    description: 'Jurisdiction subdivision name for GB_BKM',
  },
  GB_BLA: {
    defaultMessage: 'Ballymena',
    id: 'fGGEFm9Hzj',
    description: 'Jurisdiction subdivision name for GB_BLA',
  },
  GB_BLY: {
    defaultMessage: 'Ballymoney',
    id: 'Pz+G+Rer3C',
    description: 'Jurisdiction subdivision name for GB_BLY',
  },
  GB_BMH: {
    defaultMessage: 'Bournemouth',
    id: 'gLMNCLPqha',
    description: 'Jurisdiction subdivision name for GB_BMH',
  },
  GB_BNB: {
    defaultMessage: 'Banbridge',
    id: '4r7eEgh71t',
    description: 'Jurisdiction subdivision name for GB_BNB',
  },
  GB_BNE: {
    defaultMessage: 'Barnet',
    id: '50b8I9vmWY',
    description: 'Jurisdiction subdivision name for GB_BNE',
  },
  GB_BNH: {
    defaultMessage: 'Brighton and Hove',
    id: 'TnSKlacn5u',
    description: 'Jurisdiction subdivision name for GB_BNH',
  },
  GB_BNS: {
    defaultMessage: 'Barnsley',
    id: 'wTI1ywi+Ex',
    description: 'Jurisdiction subdivision name for GB_BNS',
  },
  GB_BOL: {
    defaultMessage: 'Bolton',
    id: 'PyZrw/J1a8',
    description: 'Jurisdiction subdivision name for GB_BOL',
  },
  GB_BPL: {
    defaultMessage: 'Blackpool',
    id: 'MBCo+iPHcv',
    description: 'Jurisdiction subdivision name for GB_BPL',
  },
  GB_BRC: {
    defaultMessage: 'Bracknell Forest',
    id: '57p5ielR+C',
    description: 'Jurisdiction subdivision name for GB_BRC',
  },
  GB_BRD: {
    defaultMessage: 'Bradford',
    id: 'M6RK91+ASn',
    description: 'Jurisdiction subdivision name for GB_BRD',
  },
  GB_BRY: {
    defaultMessage: 'Bromley',
    id: 'aF3+pNcx8V',
    description: 'Jurisdiction subdivision name for GB_BRY',
  },
  GB_BST: {
    defaultMessage: 'Bristol, City of',
    id: 'RcMrm00E7s',
    description: 'Jurisdiction subdivision name for GB_BST',
  },
  GB_BUR: {
    defaultMessage: 'Bury',
    id: 'XaNEQ/UTjn',
    description: 'Jurisdiction subdivision name for GB_BUR',
  },
  GB_CAM: {
    defaultMessage: 'Cambridgeshire',
    id: '/v5nQjf7Rs',
    description: 'Jurisdiction subdivision name for GB_CAM',
  },
  GB_CAY: {
    defaultMessage: 'Caerphilly',
    id: 'reFIjwFLtp',
    description: 'Jurisdiction subdivision name for GB_CAY',
  },
  GB_CBF: {
    defaultMessage: 'Central Bedfordshire',
    id: 'mZrsdMUJfC',
    description: 'Jurisdiction subdivision name for GB_CBF',
  },
  GB_CGN: {
    defaultMessage: 'Ceredigion',
    id: 'a5Z9/+88+t',
    description: 'Jurisdiction subdivision name for GB_CGN',
  },
  GB_CGV: {
    defaultMessage: 'Craigavon',
    id: 'bk5z2waSAT',
    description: 'Jurisdiction subdivision name for GB_CGV',
  },
  GB_CHE: {
    defaultMessage: 'Cheshire East',
    id: 'ZqSThXAYo8',
    description: 'Jurisdiction subdivision name for GB_CHE',
  },
  GB_CHW: {
    defaultMessage: 'Cheshire West and Chester',
    id: 'eE6+SrHqrX',
    description: 'Jurisdiction subdivision name for GB_CHW',
  },
  GB_CKF: {
    defaultMessage: 'Carrickfergus',
    id: 'FTa46dvX6F',
    description: 'Jurisdiction subdivision name for GB_CKF',
  },
  GB_CKT: {
    defaultMessage: 'Cookstown',
    id: 'reNFOofU1L',
    description: 'Jurisdiction subdivision name for GB_CKT',
  },
  GB_CLD: {
    defaultMessage: 'Calderdale',
    id: '0cmKZgB4gO',
    description: 'Jurisdiction subdivision name for GB_CLD',
  },
  GB_CLK: {
    defaultMessage: 'Clackmannanshire',
    id: 'R7e6vjz3RJ',
    description: 'Jurisdiction subdivision name for GB_CLK',
  },
  GB_CLR: {
    defaultMessage: 'Coleraine',
    id: 'jxUK0yHIvh',
    description: 'Jurisdiction subdivision name for GB_CLR',
  },
  GB_CMA: {
    defaultMessage: 'Cumbria',
    id: 'oyXNpFtTgt',
    description: 'Jurisdiction subdivision name for GB_CMA',
  },
  GB_CMD: {
    defaultMessage: 'Camden',
    id: '1lMS4tc7rS',
    description: 'Jurisdiction subdivision name for GB_CMD',
  },
  GB_CMN: {
    defaultMessage: 'Carmarthenshire',
    id: 'dZP842BJBS',
    description: 'Jurisdiction subdivision name for GB_CMN',
  },
  GB_CON: {
    defaultMessage: 'Cornwall',
    id: '5XM9+BodCe',
    description: 'Jurisdiction subdivision name for GB_CON',
  },
  GB_COV: {
    defaultMessage: 'Coventry',
    id: 'Woqj8zUZI2',
    description: 'Jurisdiction subdivision name for GB_COV',
  },
  GB_CRF: {
    defaultMessage: 'Cardiff',
    id: 'jsJEQX3f5l',
    description: 'Jurisdiction subdivision name for GB_CRF',
  },
  GB_CRY: {
    defaultMessage: 'Croydon',
    id: 'gCThIKHmXm',
    description: 'Jurisdiction subdivision name for GB_CRY',
  },
  GB_CSR: {
    defaultMessage: 'Castlereagh',
    id: 'l46kyATyg1',
    description: 'Jurisdiction subdivision name for GB_CSR',
  },
  GB_CWY: {
    defaultMessage: 'Conwy',
    id: 'm5EonKJLUY',
    description: 'Jurisdiction subdivision name for GB_CWY',
  },
  GB_DAL: {
    defaultMessage: 'Darlington',
    id: 't2DZzAXvIi',
    description: 'Jurisdiction subdivision name for GB_DAL',
  },
  GB_DBY: {
    defaultMessage: 'Derbyshire',
    id: '1eTkFc+YXC',
    description: 'Jurisdiction subdivision name for GB_DBY',
  },
  GB_DEN: {
    defaultMessage: 'Denbighshire',
    id: 'XtRn4UtSbO',
    description: 'Jurisdiction subdivision name for GB_DEN',
  },
  GB_DER: {
    defaultMessage: 'Derby',
    id: 'WyedyPhizd',
    description: 'Jurisdiction subdivision name for GB_DER',
  },
  GB_DEV: {
    defaultMessage: 'Devon',
    id: 'XsKBIg230I',
    description: 'Jurisdiction subdivision name for GB_DEV',
  },
  GB_DGN: {
    defaultMessage: 'Dungannon and South Tyrone',
    id: 'NHCRf+aXgG',
    description: 'Jurisdiction subdivision name for GB_DGN',
  },
  GB_DGY: {
    defaultMessage: 'Dumfries and Galloway',
    id: 'jWfAPgNFxt',
    description: 'Jurisdiction subdivision name for GB_DGY',
  },
  GB_DNC: {
    defaultMessage: 'Doncaster',
    id: '0BSXUJ11Hb',
    description: 'Jurisdiction subdivision name for GB_DNC',
  },
  GB_DND: {
    defaultMessage: 'Dundee City',
    id: 'TmPNmk7e7N',
    description: 'Jurisdiction subdivision name for GB_DND',
  },
  GB_DOR: {
    defaultMessage: 'Dorset',
    id: 'vlwN1zLHhe',
    description: 'Jurisdiction subdivision name for GB_DOR',
  },
  GB_DOW: {
    defaultMessage: 'Down',
    id: 'Qqlvqu2GDV',
    description: 'Jurisdiction subdivision name for GB_DOW',
  },
  GB_DRY: {
    defaultMessage: 'Derry',
    id: '/s4UmMvuep',
    description: 'Jurisdiction subdivision name for GB_DRY',
  },
  GB_DUD: {
    defaultMessage: 'Dudley',
    id: '9OJ3ODVk4h',
    description: 'Jurisdiction subdivision name for GB_DUD',
  },
  GB_DUR: {
    defaultMessage: 'Durham County',
    id: 'roelYGty3j',
    description: 'Jurisdiction subdivision name for GB_DUR',
  },
  GB_EAL: {
    defaultMessage: 'Ealing',
    id: 'scxKWwdngA',
    description: 'Jurisdiction subdivision name for GB_EAL',
  },
  GB_EAW: {
    defaultMessage: 'England and Wales',
    id: 'qmJYdYVeqe',
    description: 'Jurisdiction subdivision name for GB_EAW',
  },
  GB_EAY: {
    defaultMessage: 'East Ayrshire',
    id: 'JIx39z8V8U',
    description: 'Jurisdiction subdivision name for GB_EAY',
  },
  GB_EDH: {
    defaultMessage: 'Edinburgh, City of',
    id: 'I1isXYgaa2',
    description: 'Jurisdiction subdivision name for GB_EDH',
  },
  GB_EDU: {
    defaultMessage: 'East Dunbartonshire',
    id: 'uH88Iy8m0z',
    description: 'Jurisdiction subdivision name for GB_EDU',
  },
  GB_ELN: {
    defaultMessage: 'East Lothian',
    id: '/SlRVA5mui',
    description: 'Jurisdiction subdivision name for GB_ELN',
  },
  GB_ELS: {
    defaultMessage: 'Eilean Siar',
    id: 'k2istP4Xdy',
    description: 'Jurisdiction subdivision name for GB_ELS',
  },
  GB_ENF: {
    defaultMessage: 'Enfield',
    id: '8Wo2e/FIpl',
    description: 'Jurisdiction subdivision name for GB_ENF',
  },
  GB_ENG: {
    defaultMessage: 'England',
    id: 'M9LoE/QO2u',
    description: 'Jurisdiction subdivision name for GB_ENG',
  },
  GB_ERW: {
    defaultMessage: 'East Renfrewshire',
    id: 'ZXxQr4W1Tc',
    description: 'Jurisdiction subdivision name for GB_ERW',
  },
  GB_ERY: {
    defaultMessage: 'East Riding of Yorkshire',
    id: 'P5isHFyyvu',
    description: 'Jurisdiction subdivision name for GB_ERY',
  },
  GB_ESS: {
    defaultMessage: 'Essex',
    id: 'BdGGp6f1DO',
    description: 'Jurisdiction subdivision name for GB_ESS',
  },
  GB_ESX: {
    defaultMessage: 'East Sussex',
    id: 'TKXeBvKB4c',
    description: 'Jurisdiction subdivision name for GB_ESX',
  },
  GB_FAL: {
    defaultMessage: 'Falkirk',
    id: 'uXeVTUetkf',
    description: 'Jurisdiction subdivision name for GB_FAL',
  },
  GB_FER: {
    defaultMessage: 'Fermanagh',
    id: 'VTwgaKIEG3',
    description: 'Jurisdiction subdivision name for GB_FER',
  },
  GB_FIF: {
    defaultMessage: 'Fife',
    id: 'S4XJ1Bvjso',
    description: 'Jurisdiction subdivision name for GB_FIF',
  },
  GB_FLN: {
    defaultMessage: 'Flintshire',
    id: 'oQxDRQbY9A',
    description: 'Jurisdiction subdivision name for GB_FLN',
  },
  GB_GAT: {
    defaultMessage: 'Gateshead',
    id: 'nCGPEC42XV',
    description: 'Jurisdiction subdivision name for GB_GAT',
  },
  GB_GBN: {
    defaultMessage: 'Great Britain',
    id: 'Snvl9t1tAY',
    description: 'Jurisdiction subdivision name for GB_GBN',
  },
  GB_GLG: {
    defaultMessage: 'Glasgow City',
    id: 'dvdWxtcELY',
    description: 'Jurisdiction subdivision name for GB_GLG',
  },
  GB_GLS: {
    defaultMessage: 'Gloucestershire',
    id: 'rPnKDh/Exq',
    description: 'Jurisdiction subdivision name for GB_GLS',
  },
  GB_GRE: {
    defaultMessage: 'Greenwich',
    id: 'M78zeJeN7d',
    description: 'Jurisdiction subdivision name for GB_GRE',
  },
  GB_GWN: {
    defaultMessage: 'Gwynedd',
    id: 'BC7STAoRD7',
    description: 'Jurisdiction subdivision name for GB_GWN',
  },
  GB_HAL: {
    defaultMessage: 'Halton',
    id: 'ioEjboB9Hr',
    description: 'Jurisdiction subdivision name for GB_HAL',
  },
  GB_HAM: {
    defaultMessage: 'Hampshire',
    id: 'dfwAXcRcQP',
    description: 'Jurisdiction subdivision name for GB_HAM',
  },
  GB_HAV: {
    defaultMessage: 'Havering',
    id: 'r0GCHBgao8',
    description: 'Jurisdiction subdivision name for GB_HAV',
  },
  GB_HCK: {
    defaultMessage: 'Hackney',
    id: 'zid8+LIqZL',
    description: 'Jurisdiction subdivision name for GB_HCK',
  },
  GB_HEF: {
    defaultMessage: 'Herefordshire',
    id: 'ispELHykwo',
    description: 'Jurisdiction subdivision name for GB_HEF',
  },
  GB_HIL: {
    defaultMessage: 'Hillingdon',
    id: 'YUJ4G5ot9t',
    description: 'Jurisdiction subdivision name for GB_HIL',
  },
  GB_HLD: {
    defaultMessage: 'Highland',
    id: 'V0j96vVHCi',
    description: 'Jurisdiction subdivision name for GB_HLD',
  },
  GB_HMF: {
    defaultMessage: 'Hammersmith and Fulham',
    id: 'kfaAocviH7',
    description: 'Jurisdiction subdivision name for GB_HMF',
  },
  GB_HNS: {
    defaultMessage: 'Hounslow',
    id: '0Tkp+j/2Mi',
    description: 'Jurisdiction subdivision name for GB_HNS',
  },
  GB_HPL: {
    defaultMessage: 'Hartlepool',
    id: 'ZYsvqOpMW+',
    description: 'Jurisdiction subdivision name for GB_HPL',
  },
  GB_HRT: {
    defaultMessage: 'Hertfordshire',
    id: '1P3K2x/jNi',
    description: 'Jurisdiction subdivision name for GB_HRT',
  },
  GB_HRW: {
    defaultMessage: 'Harrow',
    id: 'C316hXN5ZN',
    description: 'Jurisdiction subdivision name for GB_HRW',
  },
  GB_HRY: {
    defaultMessage: 'Haringey',
    id: 'JOqnkTDbUI',
    description: 'Jurisdiction subdivision name for GB_HRY',
  },
  GB_IOS: {
    defaultMessage: 'Isles of Scilly',
    id: 'GcyaX52QBA',
    description: 'Jurisdiction subdivision name for GB_IOS',
  },
  GB_IOW: {
    defaultMessage: 'Isle of Wight',
    id: 'jrQvkyX6e8',
    description: 'Jurisdiction subdivision name for GB_IOW',
  },
  GB_ISL: {
    defaultMessage: 'Islington',
    id: '3H5TduOEjY',
    description: 'Jurisdiction subdivision name for GB_ISL',
  },
  GB_IVC: {
    defaultMessage: 'Inverclyde',
    id: '0bLXnA/ktB',
    description: 'Jurisdiction subdivision name for GB_IVC',
  },
  GB_KEC: {
    defaultMessage: 'Kensington and Chelsea',
    id: '/KsDwRng9l',
    description: 'Jurisdiction subdivision name for GB_KEC',
  },
  GB_KEN: {
    defaultMessage: 'Kent',
    id: 'SK1ehS5bmc',
    description: 'Jurisdiction subdivision name for GB_KEN',
  },
  GB_KHL: {
    defaultMessage: 'Kingston upon Hull',
    id: '5ncqwU662E',
    description: 'Jurisdiction subdivision name for GB_KHL',
  },
  GB_KIR: {
    defaultMessage: 'Kirklees',
    id: 'QnsPXFeLdh',
    description: 'Jurisdiction subdivision name for GB_KIR',
  },
  GB_KTT: {
    defaultMessage: 'Kingston upon Thames',
    id: 'g52If4OXaa',
    description: 'Jurisdiction subdivision name for GB_KTT',
  },
  GB_KWL: {
    defaultMessage: 'Knowsley',
    id: 'eDdT2GP7Bq',
    description: 'Jurisdiction subdivision name for GB_KWL',
  },
  GB_LAN: {
    defaultMessage: 'Lancashire',
    id: 'SKdQ5DbDyA',
    description: 'Jurisdiction subdivision name for GB_LAN',
  },
  GB_LBH: {
    defaultMessage: 'Lambeth',
    id: '2SMbD7yQeH',
    description: 'Jurisdiction subdivision name for GB_LBH',
  },
  GB_LCE: {
    defaultMessage: 'Leicester',
    id: 'lpCAsE81h9',
    description: 'Jurisdiction subdivision name for GB_LCE',
  },
  GB_LDS: {
    defaultMessage: 'Leeds',
    id: '3jqEHpzGgk',
    description: 'Jurisdiction subdivision name for GB_LDS',
  },
  GB_LEC: {
    defaultMessage: 'Leicestershire',
    id: 'DVRAAIvYv6',
    description: 'Jurisdiction subdivision name for GB_LEC',
  },
  GB_LEW: {
    defaultMessage: 'Lewisham',
    id: 'h3ouwVgSFr',
    description: 'Jurisdiction subdivision name for GB_LEW',
  },
  GB_LIN: {
    defaultMessage: 'Lincolnshire',
    id: 'sTotz0vcVG',
    description: 'Jurisdiction subdivision name for GB_LIN',
  },
  GB_LIV: {
    defaultMessage: 'Liverpool',
    id: 'uqbJrC+/6C',
    description: 'Jurisdiction subdivision name for GB_LIV',
  },
  GB_LMV: {
    defaultMessage: 'Limavady',
    id: 'Rp/pMOqdDS',
    description: 'Jurisdiction subdivision name for GB_LMV',
  },
  GB_LND: {
    defaultMessage: 'London, City of',
    id: 'prB34JOie2',
    description: 'Jurisdiction subdivision name for GB_LND',
  },
  GB_LRN: {
    defaultMessage: 'Larne',
    id: 'n8fmpUh56e',
    description: 'Jurisdiction subdivision name for GB_LRN',
  },
  GB_LSB: {
    defaultMessage: 'Lisburn',
    id: 'X+WANJZKvp',
    description: 'Jurisdiction subdivision name for GB_LSB',
  },
  GB_LUT: {
    defaultMessage: 'Luton',
    id: 'Hi4R1SaJ0Q',
    description: 'Jurisdiction subdivision name for GB_LUT',
  },
  GB_MAN: {
    defaultMessage: 'Manchester',
    id: '6M70B/llvZ',
    description: 'Jurisdiction subdivision name for GB_MAN',
  },
  GB_MDB: {
    defaultMessage: 'Middlesbrough',
    id: '4vwQLP2p9A',
    description: 'Jurisdiction subdivision name for GB_MDB',
  },
  GB_MDW: {
    defaultMessage: 'Medway',
    id: 'p4wFYrW0FP',
    description: 'Jurisdiction subdivision name for GB_MDW',
  },
  GB_MFT: {
    defaultMessage: 'Magherafelt',
    id: 'PZfXvBYpEp',
    description: 'Jurisdiction subdivision name for GB_MFT',
  },
  GB_MIK: {
    defaultMessage: 'Milton Keynes',
    id: 'Yoy7iBYhN4',
    description: 'Jurisdiction subdivision name for GB_MIK',
  },
  GB_MLN: {
    defaultMessage: 'Midlothian',
    id: 'QrYnVr3Jvx',
    description: 'Jurisdiction subdivision name for GB_MLN',
  },
  GB_MON: {
    defaultMessage: 'Monmouthshire',
    id: 'KI0wXA/axX',
    description: 'Jurisdiction subdivision name for GB_MON',
  },
  GB_MRT: {
    defaultMessage: 'Merton',
    id: 'oAewgBX0QD',
    description: 'Jurisdiction subdivision name for GB_MRT',
  },
  GB_MRY: {
    defaultMessage: 'Moray',
    id: 'cc3kXJEAuB',
    description: 'Jurisdiction subdivision name for GB_MRY',
  },
  GB_MTY: {
    defaultMessage: 'Merthyr Tydfil',
    id: 'yQe5TQVMu8',
    description: 'Jurisdiction subdivision name for GB_MTY',
  },
  GB_MYL: {
    defaultMessage: 'Moyle',
    id: 'AJH2GhaSto',
    description: 'Jurisdiction subdivision name for GB_MYL',
  },
  GB_NAY: {
    defaultMessage: 'North Ayrshire',
    id: 'GnWC83mgF/',
    description: 'Jurisdiction subdivision name for GB_NAY',
  },
  GB_NBL: {
    defaultMessage: 'Northumberland',
    id: 'mz5CAh6TFy',
    description: 'Jurisdiction subdivision name for GB_NBL',
  },
  GB_NDN: {
    defaultMessage: 'North Down',
    id: 'U+O0wGICYf',
    description: 'Jurisdiction subdivision name for GB_NDN',
  },
  GB_NEL: {
    defaultMessage: 'North East Lincolnshire',
    id: 'dfE6veZXRI',
    description: 'Jurisdiction subdivision name for GB_NEL',
  },
  GB_NET: {
    defaultMessage: 'Newcastle upon Tyne',
    id: 'w7XWklM76B',
    description: 'Jurisdiction subdivision name for GB_NET',
  },
  GB_NFK: {
    defaultMessage: 'Norfolk',
    id: 'jXHYbRKXdL',
    description: 'Jurisdiction subdivision name for GB_NFK',
  },
  GB_NGM: {
    defaultMessage: 'Nottingham',
    id: 'dTcCI15wdM',
    description: 'Jurisdiction subdivision name for GB_NGM',
  },
  GB_NIR: {
    defaultMessage: 'Northern Ireland',
    id: 'tjwFBHn1mF',
    description: 'Jurisdiction subdivision name for GB_NIR',
  },
  GB_NLK: {
    defaultMessage: 'North Lanarkshire',
    id: 'RGotiljc1X',
    description: 'Jurisdiction subdivision name for GB_NLK',
  },
  GB_NLN: {
    defaultMessage: 'North Lincolnshire',
    id: 'YEiIwDw92X',
    description: 'Jurisdiction subdivision name for GB_NLN',
  },
  GB_NSM: {
    defaultMessage: 'North Somerset',
    id: '0GkFHru/N6',
    description: 'Jurisdiction subdivision name for GB_NSM',
  },
  GB_NTA: {
    defaultMessage: 'Newtownabbey',
    id: 'V1oFN9cCZh',
    description: 'Jurisdiction subdivision name for GB_NTA',
  },
  GB_NTH: {
    defaultMessage: 'Northamptonshire',
    id: 'k3GWIDe0Fk',
    description: 'Jurisdiction subdivision name for GB_NTH',
  },
  GB_NTL: {
    defaultMessage: 'Neath Port Talbot',
    id: 'ePuW1FWThY',
    description: 'Jurisdiction subdivision name for GB_NTL',
  },
  GB_NTT: {
    defaultMessage: 'Nottinghamshire',
    id: 'UbQgSM/NIm',
    description: 'Jurisdiction subdivision name for GB_NTT',
  },
  GB_NTY: {
    defaultMessage: 'North Tyneside',
    id: 'GzL5803Gf9',
    description: 'Jurisdiction subdivision name for GB_NTY',
  },
  GB_NWM: {
    defaultMessage: 'Newham',
    id: '/mXwfqrIrR',
    description: 'Jurisdiction subdivision name for GB_NWM',
  },
  GB_NWP: {
    defaultMessage: 'Newport',
    id: 'eREcqhsiMZ',
    description: 'Jurisdiction subdivision name for GB_NWP',
  },
  GB_NYK: {
    defaultMessage: 'North Yorkshire',
    id: '8jgK+eg0lb',
    description: 'Jurisdiction subdivision name for GB_NYK',
  },
  GB_NYM: {
    defaultMessage: 'Newry and Mourne',
    id: 'UbdWdK7gw5',
    description: 'Jurisdiction subdivision name for GB_NYM',
  },
  GB_OLD: {
    defaultMessage: 'Oldham',
    id: 'EEUjl5vBS/',
    description: 'Jurisdiction subdivision name for GB_OLD',
  },
  GB_OMH: {
    defaultMessage: 'Omagh',
    id: '3fhF7H3qjZ',
    description: 'Jurisdiction subdivision name for GB_OMH',
  },
  GB_ORK: {
    defaultMessage: 'Orkney Islands',
    id: 'IKJ7rcn8WC',
    description: 'Jurisdiction subdivision name for GB_ORK',
  },
  GB_OXF: {
    defaultMessage: 'Oxfordshire',
    id: 'RW6OiWmlY6',
    description: 'Jurisdiction subdivision name for GB_OXF',
  },
  GB_PEM: {
    defaultMessage: 'Pembrokeshire',
    id: 'gQdeDTctM4',
    description: 'Jurisdiction subdivision name for GB_PEM',
  },
  GB_PKN: {
    defaultMessage: 'Perth and Kinross',
    id: '0Vwk/FUkpE',
    description: 'Jurisdiction subdivision name for GB_PKN',
  },
  GB_PLY: {
    defaultMessage: 'Plymouth',
    id: '4zoFBEWPi0',
    description: 'Jurisdiction subdivision name for GB_PLY',
  },
  GB_POL: {
    defaultMessage: 'Poole',
    id: 'ygrRiYKyAe',
    description: 'Jurisdiction subdivision name for GB_POL',
  },
  GB_POR: {
    defaultMessage: 'Portsmouth',
    id: 'to/wWkOSE1',
    description: 'Jurisdiction subdivision name for GB_POR',
  },
  GB_POW: {
    defaultMessage: 'Powys',
    id: 'L3Jb37gusY',
    description: 'Jurisdiction subdivision name for GB_POW',
  },
  GB_PTE: {
    defaultMessage: 'Peterborough',
    id: 'p6jn0FpViX',
    description: 'Jurisdiction subdivision name for GB_PTE',
  },
  GB_RCC: {
    defaultMessage: 'Redcar and Cleveland',
    id: '+EX+YymDhZ',
    description: 'Jurisdiction subdivision name for GB_RCC',
  },
  GB_RCH: {
    defaultMessage: 'Rochdale',
    id: 'Nf5YEOagN8',
    description: 'Jurisdiction subdivision name for GB_RCH',
  },
  GB_RCT: {
    defaultMessage: 'Rhondda, Cynon, Taff',
    id: 'WtH5lgYayT',
    description: 'Jurisdiction subdivision name for GB_RCT',
  },
  GB_RDB: {
    defaultMessage: 'Redbridge',
    id: '6e16Y5Cq7N',
    description: 'Jurisdiction subdivision name for GB_RDB',
  },
  GB_RDG: {
    defaultMessage: 'Reading',
    id: 'uJTlsPR39+',
    description: 'Jurisdiction subdivision name for GB_RDG',
  },
  GB_RFW: {
    defaultMessage: 'Renfrewshire',
    id: 'LKqoNxo1VX',
    description: 'Jurisdiction subdivision name for GB_RFW',
  },
  GB_RIC: {
    defaultMessage: 'Richmond upon Thames',
    id: 'upWd1DixUv',
    description: 'Jurisdiction subdivision name for GB_RIC',
  },
  GB_ROT: {
    defaultMessage: 'Rotherham',
    id: 'ANj+btPvB/',
    description: 'Jurisdiction subdivision name for GB_ROT',
  },
  GB_RUT: {
    defaultMessage: 'Rutland',
    id: 'vNzQRsdxlq',
    description: 'Jurisdiction subdivision name for GB_RUT',
  },
  GB_SAW: {
    defaultMessage: 'Sandwell',
    id: '+pOIXSdSVq',
    description: 'Jurisdiction subdivision name for GB_SAW',
  },
  GB_SAY: {
    defaultMessage: 'South Ayrshire',
    id: 'Ac/tHsrMYL',
    description: 'Jurisdiction subdivision name for GB_SAY',
  },
  GB_SCB: {
    defaultMessage: 'Scottish Borders, The',
    id: 'NHeuNYBeO5',
    description: 'Jurisdiction subdivision name for GB_SCB',
  },
  GB_SCT: {
    defaultMessage: 'Scotland',
    id: '4lfuB32Rt0',
    description: 'Jurisdiction subdivision name for GB_SCT',
  },
  GB_SFK: {
    defaultMessage: 'Suffolk',
    id: 'dxklQ48f+3',
    description: 'Jurisdiction subdivision name for GB_SFK',
  },
  GB_SFT: {
    defaultMessage: 'Sefton',
    id: 'aWTTlDFIyI',
    description: 'Jurisdiction subdivision name for GB_SFT',
  },
  GB_SGC: {
    defaultMessage: 'South Gloucestershire',
    id: 'eEb4Zl4q2Q',
    description: 'Jurisdiction subdivision name for GB_SGC',
  },
  GB_SHF: {
    defaultMessage: 'Sheffield',
    id: 'pxon+MQOco',
    description: 'Jurisdiction subdivision name for GB_SHF',
  },
  GB_SHN: {
    defaultMessage: 'St. Helens',
    id: 'saYhG3woxi',
    description: 'Jurisdiction subdivision name for GB_SHN',
  },
  GB_SHR: {
    defaultMessage: 'Shropshire',
    id: 'aN8QZ8oEuS',
    description: 'Jurisdiction subdivision name for GB_SHR',
  },
  GB_SKP: {
    defaultMessage: 'Stockport',
    id: 's5PEZ9Ayn1',
    description: 'Jurisdiction subdivision name for GB_SKP',
  },
  GB_SLF: {
    defaultMessage: 'Salford',
    id: '68c8bb2pLg',
    description: 'Jurisdiction subdivision name for GB_SLF',
  },
  GB_SLG: {
    defaultMessage: 'Slough',
    id: 'GKuJGLSOfg',
    description: 'Jurisdiction subdivision name for GB_SLG',
  },
  GB_SLK: {
    defaultMessage: 'South Lanarkshire',
    id: 'HeohfePoix',
    description: 'Jurisdiction subdivision name for GB_SLK',
  },
  GB_SND: {
    defaultMessage: 'Sunderland',
    id: '0lEW6O6yVB',
    description: 'Jurisdiction subdivision name for GB_SND',
  },
  GB_SOL: {
    defaultMessage: 'Solihull',
    id: 'oWfCoiHyCh',
    description: 'Jurisdiction subdivision name for GB_SOL',
  },
  GB_SOM: {
    defaultMessage: 'Somerset',
    id: '4tN/lyQ/c1',
    description: 'Jurisdiction subdivision name for GB_SOM',
  },
  GB_SOS: {
    defaultMessage: 'Southend-on-Sea',
    id: '1kyLhRfRzO',
    description: 'Jurisdiction subdivision name for GB_SOS',
  },
  GB_SRY: {
    defaultMessage: 'Surrey',
    id: 'Qgo2vtaxkl',
    description: 'Jurisdiction subdivision name for GB_SRY',
  },
  GB_STB: {
    defaultMessage: 'Strabane',
    id: 'QcKLijr2ZC',
    description: 'Jurisdiction subdivision name for GB_STB',
  },
  GB_STE: {
    defaultMessage: 'Stoke-on-Trent',
    id: 'J/AFON8V4B',
    description: 'Jurisdiction subdivision name for GB_STE',
  },
  GB_STG: {
    defaultMessage: 'Stirling',
    id: 'kO8sgtv1ri',
    description: 'Jurisdiction subdivision name for GB_STG',
  },
  GB_STH: {
    defaultMessage: 'Southampton',
    id: 'Gze6SvrsrL',
    description: 'Jurisdiction subdivision name for GB_STH',
  },
  GB_STN: {
    defaultMessage: 'Sutton',
    id: 'M0hFpNvvbm',
    description: 'Jurisdiction subdivision name for GB_STN',
  },
  GB_STS: {
    defaultMessage: 'Staffordshire',
    id: 'aOcZ26vEbU',
    description: 'Jurisdiction subdivision name for GB_STS',
  },
  GB_STT: {
    defaultMessage: 'Stockton-on-Tees',
    id: 'ee3RBoEM5x',
    description: 'Jurisdiction subdivision name for GB_STT',
  },
  GB_STY: {
    defaultMessage: 'South Tyneside',
    id: 'bkovXF0TXi',
    description: 'Jurisdiction subdivision name for GB_STY',
  },
  GB_SWA: {
    defaultMessage: 'Swansea',
    id: 'bDNQ/DTimK',
    description: 'Jurisdiction subdivision name for GB_SWA',
  },
  GB_SWD: {
    defaultMessage: 'Swindon',
    id: '93FMJfyyVQ',
    description: 'Jurisdiction subdivision name for GB_SWD',
  },
  GB_SWK: {
    defaultMessage: 'Southwark',
    id: 'H80xd/FiD3',
    description: 'Jurisdiction subdivision name for GB_SWK',
  },
  GB_TAM: {
    defaultMessage: 'Tameside',
    id: 'dg6MAk766Q',
    description: 'Jurisdiction subdivision name for GB_TAM',
  },
  GB_TFW: {
    defaultMessage: 'Telford and Wrekin',
    id: 'SBGt6dSMlm',
    description: 'Jurisdiction subdivision name for GB_TFW',
  },
  GB_THR: {
    defaultMessage: 'Thurrock',
    id: 'IcrPEvpi/T',
    description: 'Jurisdiction subdivision name for GB_THR',
  },
  GB_TOB: {
    defaultMessage: 'Torbay',
    id: '5Rrn3BkjWY',
    description: 'Jurisdiction subdivision name for GB_TOB',
  },
  GB_TOF: {
    defaultMessage: 'Torfaen',
    id: '7sWbX83XRV',
    description: 'Jurisdiction subdivision name for GB_TOF',
  },
  GB_TRF: {
    defaultMessage: 'Trafford',
    id: 'Z7Dwe6Gg4y',
    description: 'Jurisdiction subdivision name for GB_TRF',
  },
  GB_TWH: {
    defaultMessage: 'Tower Hamlets',
    id: 'fJCQHkWgkV',
    description: 'Jurisdiction subdivision name for GB_TWH',
  },
  GB_UKM: {
    defaultMessage: 'United Kingdom',
    id: '7CFlQuq1IQ',
    description: 'Jurisdiction subdivision name for GB_UKM',
  },
  GB_VGL: {
    defaultMessage: 'Vale of Glamorgan, The',
    id: '2XgazPWhG/',
    description: 'Jurisdiction subdivision name for GB_VGL',
  },
  GB_WAR: {
    defaultMessage: 'Warwickshire',
    id: 'Tk7MfvChaQ',
    description: 'Jurisdiction subdivision name for GB_WAR',
  },
  GB_WBK: {
    defaultMessage: 'West Berkshire',
    id: 'Ds+DXBM4FW',
    description: 'Jurisdiction subdivision name for GB_WBK',
  },
  GB_WDU: {
    defaultMessage: 'West Dunbartonshire',
    id: 'zyZ1qI4zgc',
    description: 'Jurisdiction subdivision name for GB_WDU',
  },
  GB_WFT: {
    defaultMessage: 'Waltham Forest',
    id: 'i5lBYo6IxF',
    description: 'Jurisdiction subdivision name for GB_WFT',
  },
  GB_WGN: {
    defaultMessage: 'Wigan',
    id: 'DFx+W/kqyx',
    description: 'Jurisdiction subdivision name for GB_WGN',
  },
  GB_WIL: {
    defaultMessage: 'Wiltshire',
    id: 'SX7+H0WweO',
    description: 'Jurisdiction subdivision name for GB_WIL',
  },
  GB_WKF: {
    defaultMessage: 'Wakefield',
    id: 'dYqz2jDhCj',
    description: 'Jurisdiction subdivision name for GB_WKF',
  },
  GB_WLL: {
    defaultMessage: 'Walsall',
    id: 'O7tk3zPUIi',
    description: 'Jurisdiction subdivision name for GB_WLL',
  },
  GB_WLN: {
    defaultMessage: 'West Lothian',
    id: 'MDixMgLfa6',
    description: 'Jurisdiction subdivision name for GB_WLN',
  },
  GB_WLS: {
    defaultMessage: 'Wales',
    id: '0EatF10/hD',
    description: 'Jurisdiction subdivision name for GB_WLS',
  },
  GB_WLV: {
    defaultMessage: 'Wolverhampton',
    id: 'zYG7yUEhWZ',
    description: 'Jurisdiction subdivision name for GB_WLV',
  },
  GB_WND: {
    defaultMessage: 'Wandsworth',
    id: 'mQEvTGfxsk',
    description: 'Jurisdiction subdivision name for GB_WND',
  },
  GB_WNM: {
    defaultMessage: 'Windsor and Maidenhead',
    id: 'VAL/E/bAbK',
    description: 'Jurisdiction subdivision name for GB_WNM',
  },
  GB_WOK: {
    defaultMessage: 'Wokingham',
    id: '0BeZ0pKV2a',
    description: 'Jurisdiction subdivision name for GB_WOK',
  },
  GB_WOR: {
    defaultMessage: 'Worcestershire',
    id: '4bb82hammr',
    description: 'Jurisdiction subdivision name for GB_WOR',
  },
  GB_WRL: {
    defaultMessage: 'Wirral',
    id: '1OXYIugZPM',
    description: 'Jurisdiction subdivision name for GB_WRL',
  },
  GB_WRT: {
    defaultMessage: 'Warrington',
    id: 'R+Wn6lq8T1',
    description: 'Jurisdiction subdivision name for GB_WRT',
  },
  GB_WRX: {
    defaultMessage: 'Wrexham',
    id: '5mXlVQYvpA',
    description: 'Jurisdiction subdivision name for GB_WRX',
  },
  GB_WSM: {
    defaultMessage: 'Westminster',
    id: 'LmfLzhQ1EY',
    description: 'Jurisdiction subdivision name for GB_WSM',
  },
  GB_WSX: {
    defaultMessage: 'West Sussex',
    id: 'pfL5flga0e',
    description: 'Jurisdiction subdivision name for GB_WSX',
  },
  GB_YOR: {
    defaultMessage: 'York',
    id: 'acXcQVmikU',
    description: 'Jurisdiction subdivision name for GB_YOR',
  },
  GB_ZET: {
    defaultMessage: 'Shetland Islands',
    id: '3aktqAE1mb',
    description: 'Jurisdiction subdivision name for GB_ZET',
  },
  JP_01: {
    defaultMessage: 'Hokkaido',
    id: 'm3D0zdVdbj',
    description: 'Jurisdiction subdivision name for JP_01',
  },
  JP_02: {
    defaultMessage: 'Aomori',
    id: 'jT6COCcurU',
    description: 'Jurisdiction subdivision name for JP_02',
  },
  JP_03: {
    defaultMessage: 'Iwate',
    id: 'kVCQBlVyhb',
    description: 'Jurisdiction subdivision name for JP_03',
  },
  JP_04: {
    defaultMessage: 'Miyagi',
    id: 'EU1mvUKpbU',
    description: 'Jurisdiction subdivision name for JP_04',
  },
  JP_05: {
    defaultMessage: 'Akita',
    id: 'AMQllFf8jq',
    description: 'Jurisdiction subdivision name for JP_05',
  },
  JP_06: {
    defaultMessage: 'Yamagata',
    id: 'FYVzRtshCA',
    description: 'Jurisdiction subdivision name for JP_06',
  },
  JP_07: {
    defaultMessage: 'Fukushima',
    id: 'aBvfiGTxWb',
    description: 'Jurisdiction subdivision name for JP_07',
  },
  JP_08: {
    defaultMessage: 'Ibaraki',
    id: '73/l+gxVQp',
    description: 'Jurisdiction subdivision name for JP_08',
  },
  JP_09: {
    defaultMessage: 'Tochigi',
    id: 'To0CjKGkez',
    description: 'Jurisdiction subdivision name for JP_09',
  },
  JP_10: {
    defaultMessage: 'Gunma',
    id: '8QAPDMBeG2',
    description: 'Jurisdiction subdivision name for JP_10',
  },
  JP_11: {
    defaultMessage: 'Saitama',
    id: '+5lONC9Q1v',
    description: 'Jurisdiction subdivision name for JP_11',
  },
  JP_12: {
    defaultMessage: 'Chiba',
    id: 'Vd4ldxjbC8',
    description: 'Jurisdiction subdivision name for JP_12',
  },
  JP_13: {
    defaultMessage: 'Tokyo',
    id: 'R/+UxiJ/Dv',
    description: 'Jurisdiction subdivision name for JP_13',
  },
  JP_14: {
    defaultMessage: 'Kanagawa',
    id: 'nexhoXZ4Xs',
    description: 'Jurisdiction subdivision name for JP_14',
  },
  JP_15: {
    defaultMessage: 'Niigata',
    id: 'ixtuoA3BIi',
    description: 'Jurisdiction subdivision name for JP_15',
  },
  JP_16: {
    defaultMessage: 'Toyama',
    id: 'gTj8B9cSSJ',
    description: 'Jurisdiction subdivision name for JP_16',
  },
  JP_17: {
    defaultMessage: 'Ishikawa',
    id: '45L2AmgV0q',
    description: 'Jurisdiction subdivision name for JP_17',
  },
  JP_18: {
    defaultMessage: 'Fukui',
    id: '7LmmmIvocH',
    description: 'Jurisdiction subdivision name for JP_18',
  },
  JP_19: {
    defaultMessage: 'Yamanashi',
    id: 'hXi7LN6eTx',
    description: 'Jurisdiction subdivision name for JP_19',
  },
  JP_20: {
    defaultMessage: 'Nagano',
    id: '72vqv3j6gB',
    description: 'Jurisdiction subdivision name for JP_20',
  },
  JP_21: {
    defaultMessage: 'Gifu',
    id: 'jnvz3zZMxc',
    description: 'Jurisdiction subdivision name for JP_21',
  },
  JP_22: {
    defaultMessage: 'Shizuoka',
    id: 'mHTsoRLf3b',
    description: 'Jurisdiction subdivision name for JP_22',
  },
  JP_23: {
    defaultMessage: 'Aichi',
    id: 'nNBvqwjYet',
    description: 'Jurisdiction subdivision name for JP_23',
  },
  JP_24: {
    defaultMessage: 'Mie',
    id: 'fdnclQifR7',
    description: 'Jurisdiction subdivision name for JP_24',
  },
  JP_25: {
    defaultMessage: 'Shiga',
    id: 'NX3/B8TDjB',
    description: 'Jurisdiction subdivision name for JP_25',
  },
  JP_26: {
    defaultMessage: 'Kyoto',
    id: 'z2p0SvN9bs',
    description: 'Jurisdiction subdivision name for JP_26',
  },
  JP_27: {
    defaultMessage: 'Osaka',
    id: 'cLqudbRBSu',
    description: 'Jurisdiction subdivision name for JP_27',
  },
  JP_28: {
    defaultMessage: 'Hyogo',
    id: 'i26JaetF5O',
    description: 'Jurisdiction subdivision name for JP_28',
  },
  JP_29: {
    defaultMessage: 'Nara',
    id: 'aZ5jL6ePHV',
    description: 'Jurisdiction subdivision name for JP_29',
  },
  JP_30: {
    defaultMessage: 'Wakayama',
    id: 'ZEgzTX8qmS',
    description: 'Jurisdiction subdivision name for JP_30',
  },
  JP_31: {
    defaultMessage: 'Tottori',
    id: 'Ad9mswZT9q',
    description: 'Jurisdiction subdivision name for JP_31',
  },
  JP_32: {
    defaultMessage: 'Shimane',
    id: 'Uxd3gGue+G',
    description: 'Jurisdiction subdivision name for JP_32',
  },
  JP_33: {
    defaultMessage: 'Okayama',
    id: 'pCbDr8XHRr',
    description: 'Jurisdiction subdivision name for JP_33',
  },
  JP_34: {
    defaultMessage: 'Hiroshima',
    id: 'w4r7/3WBQ1',
    description: 'Jurisdiction subdivision name for JP_34',
  },
  JP_35: {
    defaultMessage: 'Yamaguchi',
    id: 'Owz8h50UqR',
    description: 'Jurisdiction subdivision name for JP_35',
  },
  JP_36: {
    defaultMessage: 'Tokushima',
    id: 'FXlMINf8N2',
    description: 'Jurisdiction subdivision name for JP_36',
  },
  JP_37: {
    defaultMessage: 'Kagawa',
    id: 'VoPXP8rKu7',
    description: 'Jurisdiction subdivision name for JP_37',
  },
  JP_38: {
    defaultMessage: 'Ehime',
    id: 'R7/hTVb4un',
    description: 'Jurisdiction subdivision name for JP_38',
  },
  JP_39: {
    defaultMessage: 'Kochi',
    id: 'rPJOO78Mrd',
    description: 'Jurisdiction subdivision name for JP_39',
  },
  JP_40: {
    defaultMessage: 'Fukuoka',
    id: 'cFmbzNt1Ev',
    description: 'Jurisdiction subdivision name for JP_40',
  },
  JP_41: {
    defaultMessage: 'Saga',
    id: 'vrgiRr1RSo',
    description: 'Jurisdiction subdivision name for JP_41',
  },
  JP_42: {
    defaultMessage: 'Nagasaki',
    id: 'iAnEg9fDdG',
    description: 'Jurisdiction subdivision name for JP_42',
  },
  JP_43: {
    defaultMessage: 'Kumamoto',
    id: '4+kcjtlaDO',
    description: 'Jurisdiction subdivision name for JP_43',
  },
  JP_44: {
    defaultMessage: 'Oita',
    id: '5VI9+Bqp1H',
    description: 'Jurisdiction subdivision name for JP_44',
  },
  JP_45: {
    defaultMessage: 'Miyazaki',
    id: 'LHDGk3KpHL',
    description: 'Jurisdiction subdivision name for JP_45',
  },
  JP_46: {
    defaultMessage: 'Kagoshima',
    id: '1GVnoaEYJ1',
    description: 'Jurisdiction subdivision name for JP_46',
  },
  JP_47: {
    defaultMessage: 'Okinawa',
    id: 'j0mAiXBO22',
    description: 'Jurisdiction subdivision name for JP_47',
  },
  MX_AGU: {
    defaultMessage: 'Aguascalientes',
    id: 'IypbfV0fKV',
    description: 'Jurisdiction subdivision name for MX_AGU',
  },
  MX_BCN: {
    defaultMessage: 'Baja California',
    id: '4qieGZ/B3X',
    description: 'Jurisdiction subdivision name for MX_BCN',
  },
  MX_BCS: {
    defaultMessage: 'Baja California Sur',
    id: 'AhowQSYxrB',
    description: 'Jurisdiction subdivision name for MX_BCS',
  },
  MX_CAM: {
    defaultMessage: 'Campeche',
    id: 'VYg3EC3bpc',
    description: 'Jurisdiction subdivision name for MX_CAM',
  },
  MX_CHH: {
    defaultMessage: 'Chihuahua',
    id: 'yyfxz62610',
    description: 'Jurisdiction subdivision name for MX_CHH',
  },
  MX_CHP: {
    defaultMessage: 'Chiapas',
    id: '0artJ8Ee9R',
    description: 'Jurisdiction subdivision name for MX_CHP',
  },
  MX_CMX: {
    defaultMessage: 'Ciudad de México',
    id: '+Ivbf//Am6',
    description: 'Jurisdiction subdivision name for MX_CMX',
  },
  MX_COA: {
    defaultMessage: 'Coahuila de Zaragoza',
    id: 'xK9rnLyJCf',
    description: 'Jurisdiction subdivision name for MX_COA',
  },
  MX_COL: {
    defaultMessage: 'Colima',
    id: 'ZOrmNzxo7o',
    description: 'Jurisdiction subdivision name for MX_COL',
  },
  MX_DUR: {
    defaultMessage: 'Durango',
    id: 'lWKtdqFYYO',
    description: 'Jurisdiction subdivision name for MX_DUR',
  },
  MX_GRO: {
    defaultMessage: 'Guerrero',
    id: 'wZzxDrH0qK',
    description: 'Jurisdiction subdivision name for MX_GRO',
  },
  MX_GUA: {
    defaultMessage: 'Guanajuato',
    id: 'njlmq+FUxo',
    description: 'Jurisdiction subdivision name for MX_GUA',
  },
  MX_HID: {
    defaultMessage: 'Hidalgo',
    id: 'i0LN5K10vR',
    description: 'Jurisdiction subdivision name for MX_HID',
  },
  MX_JAL: {
    defaultMessage: 'Jalisco',
    id: '7/k37zJVUf',
    description: 'Jurisdiction subdivision name for MX_JAL',
  },
  MX_MEX: {
    defaultMessage: 'México',
    id: '4+6N7O6ckX',
    description: 'Jurisdiction subdivision name for MX_MEX',
  },
  MX_MIC: {
    defaultMessage: 'Michoacán de Ocampo',
    id: '9sVzCPO7Ay',
    description: 'Jurisdiction subdivision name for MX_MIC',
  },
  MX_MOR: {
    defaultMessage: 'Morelos',
    id: 'rUWj2dgcIK',
    description: 'Jurisdiction subdivision name for MX_MOR',
  },
  MX_NAY: {
    defaultMessage: 'Nayarit',
    id: 'H98ChJG7n9',
    description: 'Jurisdiction subdivision name for MX_NAY',
  },
  MX_NLE: {
    defaultMessage: 'Nuevo León',
    id: '8roJ1IunoP',
    description: 'Jurisdiction subdivision name for MX_NLE',
  },
  MX_OAX: {
    defaultMessage: 'Oaxaca',
    id: 'MH3pPqGpL0',
    description: 'Jurisdiction subdivision name for MX_OAX',
  },
  MX_PUE: {
    defaultMessage: 'Puebla',
    id: 'rgMWgANgc4',
    description: 'Jurisdiction subdivision name for MX_PUE',
  },
  MX_QUE: {
    defaultMessage: 'Querétaro',
    id: '0bI5q+tNx4',
    description: 'Jurisdiction subdivision name for MX_QUE',
  },
  MX_ROO: {
    defaultMessage: 'Quintana Roo',
    id: 'GDyMD1iVe0',
    description: 'Jurisdiction subdivision name for MX_ROO',
  },
  MX_SIN: {
    defaultMessage: 'Sinaloa',
    id: 'EAxfA9VoDJ',
    description: 'Jurisdiction subdivision name for MX_SIN',
  },
  MX_SLP: {
    defaultMessage: 'San Luis Potosí',
    id: 'GSi7gdXtTU',
    description: 'Jurisdiction subdivision name for MX_SLP',
  },
  MX_SON: {
    defaultMessage: 'Sonora',
    id: 'wdEkrjtWdn',
    description: 'Jurisdiction subdivision name for MX_SON',
  },
  MX_TAB: {
    defaultMessage: 'Tabasco',
    id: 'wsCfNeWnfq',
    description: 'Jurisdiction subdivision name for MX_TAB',
  },
  MX_TAM: {
    defaultMessage: 'Tamaulipas',
    id: '5Zyhv4i7fY',
    description: 'Jurisdiction subdivision name for MX_TAM',
  },
  MX_TLA: {
    defaultMessage: 'Tlaxcala',
    id: 'aCLLMIpigA',
    description: 'Jurisdiction subdivision name for MX_TLA',
  },
  MX_VER: {
    defaultMessage: 'Veracruz de Ignacio de la Llave',
    id: 'zPKL+tY2QN',
    description: 'Jurisdiction subdivision name for MX_VER',
  },
  MX_YUC: {
    defaultMessage: 'Yucatán',
    id: 'li/SvYKURe',
    description: 'Jurisdiction subdivision name for MX_YUC',
  },
  MX_ZAC: {
    defaultMessage: 'Zacatecas',
    id: 'POwYXsGjux',
    description: 'Jurisdiction subdivision name for MX_ZAC',
  },
  NZ_AUK: {
    defaultMessage: 'Auckland',
    id: 'r8tI8qD49m',
    description: 'Jurisdiction subdivision name for NZ_AUK',
  },
  NZ_BOP: {
    defaultMessage: 'Bay of Plenty',
    id: 'rbe5UJWqL8',
    description: 'Jurisdiction subdivision name for NZ_BOP',
  },
  NZ_CAN: {
    defaultMessage: 'Canterbury',
    id: 'wchPQfkBwh',
    description: 'Jurisdiction subdivision name for NZ_CAN',
  },
  NZ_CIT: {
    defaultMessage: 'Chatham Islands Territory',
    id: 'BgpMfYQfiw',
    description: 'Jurisdiction subdivision name for NZ_CIT',
  },
  NZ_GIS: {
    defaultMessage: 'Gisborne',
    id: 'iuqZks1vmi',
    description: 'Jurisdiction subdivision name for NZ_GIS',
  },
  NZ_HKB: {
    defaultMessage: "Hawke's Bay",
    id: 'eqvWR1L0vW',
    description: 'Jurisdiction subdivision name for NZ_HKB',
  },
  NZ_MBH: {
    defaultMessage: 'Marlborough',
    id: 'C1NWGZsYPF',
    description: 'Jurisdiction subdivision name for NZ_MBH',
  },
  NZ_MWT: {
    defaultMessage: 'Manawatū-Whanganui',
    id: '2XxhIzPwSG',
    description: 'Jurisdiction subdivision name for NZ_MWT',
  },
  NZ_N: {
    defaultMessage: 'North Island',
    id: 'yke8rEnlXB',
    description: 'Jurisdiction subdivision name for NZ_N',
  },
  NZ_NSN: {
    defaultMessage: 'Nelson',
    id: '3QQhWFerWj',
    description: 'Jurisdiction subdivision name for NZ_NSN',
  },
  NZ_NTL: {
    defaultMessage: 'Northland',
    id: 'eggfB6hPHf',
    description: 'Jurisdiction subdivision name for NZ_NTL',
  },
  NZ_OTA: {
    defaultMessage: 'Otago',
    id: '+8xEqxEGy3',
    description: 'Jurisdiction subdivision name for NZ_OTA',
  },
  NZ_S: {
    defaultMessage: 'South Island',
    id: 'NMmU1dvq97',
    description: 'Jurisdiction subdivision name for NZ_S',
  },
  NZ_STL: {
    defaultMessage: 'Southland',
    id: 'CmD+wwSDWh',
    description: 'Jurisdiction subdivision name for NZ_STL',
  },
  NZ_TAS: {
    defaultMessage: 'Tasman',
    id: 'FLr18ZaPqn',
    description: 'Jurisdiction subdivision name for NZ_TAS',
  },
  NZ_TKI: {
    defaultMessage: 'Taranaki',
    id: 'l+AqtzNMaR',
    description: 'Jurisdiction subdivision name for NZ_TKI',
  },
  NZ_WGN: {
    defaultMessage: 'Greater Wellington',
    id: '9Rf7238ui1',
    description: 'Jurisdiction subdivision name for NZ_WGN',
  },
  NZ_WKO: {
    defaultMessage: 'Waikato',
    id: 'ISEbpGW4YT',
    description: 'Jurisdiction subdivision name for NZ_WKO',
  },
  NZ_WTC: {
    defaultMessage: 'West Coast',
    id: 'wZJ3yGUy/W',
    description: 'Jurisdiction subdivision name for NZ_WTC',
  },
  SG_01: {
    defaultMessage: 'Central Singapore',
    id: 'Y53Mz95U2F',
    description: 'Jurisdiction subdivision name for SG_01',
  },
  SG_02: {
    defaultMessage: 'North East',
    id: 'XqRBx8/xHy',
    description: 'Jurisdiction subdivision name for SG_02',
  },
  SG_03: {
    defaultMessage: 'North West',
    id: '6o+9WQXbdZ',
    description: 'Jurisdiction subdivision name for SG_03',
  },
  SG_04: {
    defaultMessage: 'South East',
    id: 'nLHKOZtX9b',
    description: 'Jurisdiction subdivision name for SG_04',
  },
  SG_05: {
    defaultMessage: 'South West',
    id: 'NSy2sCcy9q',
    description: 'Jurisdiction subdivision name for SG_05',
  },
  US_AK: {
    defaultMessage: 'Alaska',
    id: 'mmvc6rhv7Z',
    description: 'Jurisdiction subdivision name for US_AK',
  },
  US_AL: {
    defaultMessage: 'Alabama',
    id: 'IVcu5HqDx6',
    description: 'Jurisdiction subdivision name for US_AL',
  },
  US_AR: {
    defaultMessage: 'Arkansas',
    id: 'nVhXfthur1',
    description: 'Jurisdiction subdivision name for US_AR',
  },
  US_AS: {
    defaultMessage: 'American Samoa',
    id: 'K0KaBy8Bga',
    description: 'Jurisdiction subdivision name for US_AS',
  },
  US_AZ: {
    defaultMessage: 'Arizona',
    id: 'tV7BBhjhMN',
    description: 'Jurisdiction subdivision name for US_AZ',
  },
  US_CA: {
    defaultMessage: 'California',
    id: 'flJfe+VkVh',
    description: 'Jurisdiction subdivision name for US_CA',
  },
  US_CO: {
    defaultMessage: 'Colorado',
    id: 'ow/XJUF7Xd',
    description: 'Jurisdiction subdivision name for US_CO',
  },
  US_CT: {
    defaultMessage: 'Connecticut',
    id: 'kpwUOyHSZV',
    description: 'Jurisdiction subdivision name for US_CT',
  },
  US_DC: {
    defaultMessage: 'District of Columbia',
    id: 'j46NcsXbin',
    description: 'Jurisdiction subdivision name for US_DC',
  },
  US_DE: {
    defaultMessage: 'Delaware',
    id: '30YIW23tCn',
    description: 'Jurisdiction subdivision name for US_DE',
  },
  US_FL: {
    defaultMessage: 'Florida',
    id: '0rkT++mcRq',
    description: 'Jurisdiction subdivision name for US_FL',
  },
  US_GA: {
    defaultMessage: 'Georgia',
    id: 'kRE/wMYQW/',
    description: 'Jurisdiction subdivision name for US_GA',
  },
  US_GU: {
    defaultMessage: 'Guam',
    id: 'N0JISIfc3O',
    description: 'Jurisdiction subdivision name for US_GU',
  },
  US_HI: {
    defaultMessage: 'Hawaii',
    id: '0DbwGkfuJD',
    description: 'Jurisdiction subdivision name for US_HI',
  },
  US_IA: {
    defaultMessage: 'Iowa',
    id: '5mS1xI/5IM',
    description: 'Jurisdiction subdivision name for US_IA',
  },
  US_ID: {
    defaultMessage: 'Idaho',
    id: 'g6bfQcOj3W',
    description: 'Jurisdiction subdivision name for US_ID',
  },
  US_IL: {
    defaultMessage: 'Illinois',
    id: 'OOhaHnPkoh',
    description: 'Jurisdiction subdivision name for US_IL',
  },
  US_IN: {
    defaultMessage: 'Indiana',
    id: '8CCElcGAh3',
    description: 'Jurisdiction subdivision name for US_IN',
  },
  US_KS: {
    defaultMessage: 'Kansas',
    id: 'WYaTO+pNjl',
    description: 'Jurisdiction subdivision name for US_KS',
  },
  US_KY: {
    defaultMessage: 'Kentucky',
    id: 'JxDLiQN/EQ',
    description: 'Jurisdiction subdivision name for US_KY',
  },
  US_LA: {
    defaultMessage: 'Louisiana',
    id: 'Ib2TfwA/xA',
    description: 'Jurisdiction subdivision name for US_LA',
  },
  US_MA: {
    defaultMessage: 'Massachusetts',
    id: 'X59H9kD/zA',
    description: 'Jurisdiction subdivision name for US_MA',
  },
  US_MD: {
    defaultMessage: 'Maryland',
    id: 'k+L763aGxg',
    description: 'Jurisdiction subdivision name for US_MD',
  },
  US_ME: {
    defaultMessage: 'Maine',
    id: '3wgNKnm3uX',
    description: 'Jurisdiction subdivision name for US_ME',
  },
  US_MI: {
    defaultMessage: 'Michigan',
    id: 'eox4MebJhy',
    description: 'Jurisdiction subdivision name for US_MI',
  },
  US_MN: {
    defaultMessage: 'Minnesota',
    id: 'JDAd9AsdNW',
    description: 'Jurisdiction subdivision name for US_MN',
  },
  US_MO: {
    defaultMessage: 'Missouri',
    id: 'd9gugjGiZd',
    description: 'Jurisdiction subdivision name for US_MO',
  },
  US_MP: {
    defaultMessage: 'Northern Mariana Islands',
    id: 'RPm+zIy5Db',
    description: 'Jurisdiction subdivision name for US_MP',
  },
  US_MS: {
    defaultMessage: 'Mississippi',
    id: 'Q4CUaR8XYe',
    description: 'Jurisdiction subdivision name for US_MS',
  },
  US_MT: {
    defaultMessage: 'Montana',
    id: 'lNZx5+JH1m',
    description: 'Jurisdiction subdivision name for US_MT',
  },
  US_NC: {
    defaultMessage: 'North Carolina',
    id: 'cs/FkPYxcl',
    description: 'Jurisdiction subdivision name for US_NC',
  },
  US_ND: {
    defaultMessage: 'North Dakota',
    id: 'bEHe5FAQcX',
    description: 'Jurisdiction subdivision name for US_ND',
  },
  US_NE: {
    defaultMessage: 'Nebraska',
    id: '5Tz5ekBdBE',
    description: 'Jurisdiction subdivision name for US_NE',
  },
  US_NH: {
    defaultMessage: 'New Hampshire',
    id: 'BiqXPpA+Hz',
    description: 'Jurisdiction subdivision name for US_NH',
  },
  US_NJ: {
    defaultMessage: 'New Jersey',
    id: 'OMvkg4QerM',
    description: 'Jurisdiction subdivision name for US_NJ',
  },
  US_NM: {
    defaultMessage: 'New Mexico',
    id: 'xRRtV5Z61p',
    description: 'Jurisdiction subdivision name for US_NM',
  },
  US_NV: {
    defaultMessage: 'Nevada',
    id: 'P2KVascUMN',
    description: 'Jurisdiction subdivision name for US_NV',
  },
  US_NY: {
    defaultMessage: 'New York',
    id: '+iQjxKlZZC',
    description: 'Jurisdiction subdivision name for US_NY',
  },
  US_OH: {
    defaultMessage: 'Ohio',
    id: '737ZIzmg40',
    description: 'Jurisdiction subdivision name for US_OH',
  },
  US_OK: {
    defaultMessage: 'Oklahoma',
    id: 'evLsZescky',
    description: 'Jurisdiction subdivision name for US_OK',
  },
  US_OR: {
    defaultMessage: 'Oregon',
    id: 'TNQNAOtIm5',
    description: 'Jurisdiction subdivision name for US_OR',
  },
  US_PA: {
    defaultMessage: 'Pennsylvania',
    id: 'GDeLCXPDck',
    description: 'Jurisdiction subdivision name for US_PA',
  },
  US_PR: {
    defaultMessage: 'Puerto Rico',
    id: 'UEaSNtDCQe',
    description: 'Jurisdiction subdivision name for US_PR',
  },
  US_RI: {
    defaultMessage: 'Rhode Island',
    id: '+gwRmlgWTH',
    description: 'Jurisdiction subdivision name for US_RI',
  },
  US_SC: {
    defaultMessage: 'South Carolina',
    id: 't8mUpnt7TT',
    description: 'Jurisdiction subdivision name for US_SC',
  },
  US_SD: {
    defaultMessage: 'South Dakota',
    id: 'q0QXuI2Juo',
    description: 'Jurisdiction subdivision name for US_SD',
  },
  US_TN: {
    defaultMessage: 'Tennessee',
    id: 'm6Qa0hW9Gb',
    description: 'Jurisdiction subdivision name for US_TN',
  },
  US_TX: {
    defaultMessage: 'Texas',
    id: 'mdgTRk8hnM',
    description: 'Jurisdiction subdivision name for US_TX',
  },
  US_UM: {
    defaultMessage: 'United States Minor Outlying Islands',
    id: 'vAojIfeyeP',
    description: 'Jurisdiction subdivision name for US_UM',
  },
  US_UT: {
    defaultMessage: 'Utah',
    id: 'FMoa2bHhSM',
    description: 'Jurisdiction subdivision name for US_UT',
  },
  US_VA: {
    defaultMessage: 'Virginia',
    id: '1Fsvbvv6k/',
    description: 'Jurisdiction subdivision name for US_VA',
  },
  US_VI: {
    defaultMessage: 'Virgin Islands, U.S.',
    id: 'Cwf6OwI+Rj',
    description: 'Jurisdiction subdivision name for US_VI',
  },
  US_VT: {
    defaultMessage: 'Vermont',
    id: 'd36DQqnE3n',
    description: 'Jurisdiction subdivision name for US_VT',
  },
  US_WA: {
    defaultMessage: 'Washington',
    id: 'Le3lTlKt2t',
    description: 'Jurisdiction subdivision name for US_WA',
  },
  US_WI: {
    defaultMessage: 'Wisconsin',
    id: 'IrypwdKq1P',
    description: 'Jurisdiction subdivision name for US_WI',
  },
  US_WV: {
    defaultMessage: 'West Virginia',
    id: 'uc0G3dduUV',
    description: 'Jurisdiction subdivision name for US_WV',
  },
  US_WY: {
    defaultMessage: 'Wyoming',
    id: 'CqJCImNOf9',
    description: 'Jurisdiction subdivision name for US_WY',
  },
  ZA_EC: {
    defaultMessage: 'Eastern Cape',
    id: 'm8rqgSlSc1',
    description: 'Jurisdiction subdivision name for ZA_EC',
  },
  ZA_FS: {
    defaultMessage: 'Free State',
    id: 'WZd/YBN36g',
    description: 'Jurisdiction subdivision name for ZA_FS',
  },
  ZA_GP: {
    defaultMessage: 'Gauteng',
    id: 'PxillH8r/5',
    description: 'Jurisdiction subdivision name for ZA_GP',
  },
  ZA_GT: {
    defaultMessage: 'Gauteng',
    id: 'b4S9iTOm3a',
    description: 'Jurisdiction subdivision name for ZA_GT',
  },
  ZA_KZN: {
    defaultMessage: 'KwaZulu-Natal',
    id: 'dIKILGMyHa',
    description: 'Jurisdiction subdivision name for ZA_KZN',
  },
  ZA_LP: {
    defaultMessage: 'Limpopo',
    id: 'g0/bbhRT5T',
    description: 'Jurisdiction subdivision name for ZA_LP',
  },
  ZA_MP: {
    defaultMessage: 'Mpumalanga',
    id: 'TifxFbuVYN',
    description: 'Jurisdiction subdivision name for ZA_MP',
  },
  ZA_NC: {
    defaultMessage: 'Northern Cape',
    id: 'ov9V32lE4R',
    description: 'Jurisdiction subdivision name for ZA_NC',
  },
  ZA_NL: {
    defaultMessage: 'KwaZulu-Natal',
    id: 'hvb7QzJYUb',
    description: 'Jurisdiction subdivision name for ZA_NL',
  },
  ZA_NW: {
    defaultMessage: 'North West',
    id: 'NLkDS0Up61',
    description: 'Jurisdiction subdivision name for ZA_NW',
  },
  ZA_WC: {
    defaultMessage: 'Western Cape',
    id: 'rRCbhF+brG',
    description: 'Jurisdiction subdivision name for ZA_WC',
  },
  CA_AB: {
    defaultMessage: 'Alberta',
    id: 'j4po2zCvgu',
    description: 'Jurisdiction subdivision name for CA_AB',
  },
  CA_BC: {
    defaultMessage: 'British Columbia',
    id: 'EsTVHEFjXI',
    description: 'Jurisdiction subdivision name for CA_BC',
  },
  CA_MB: {
    defaultMessage: 'Manitoba',
    id: '7Oap7Bx8LF',
    description: 'Jurisdiction subdivision name for CA_MB',
  },
  CA_NB: {
    defaultMessage: 'New Brunswick',
    id: 'oV7viF6j3G',
    description: 'Jurisdiction subdivision name for CA_NB',
  },
  CA_NL: {
    defaultMessage: 'Newfoundland and Labrador',
    id: '7Ph/N/rrpr',
    description: 'Jurisdiction subdivision name for CA_NL',
  },
  CA_NS: {
    defaultMessage: 'Nova Scotia',
    id: 'KtMoeKVtoB',
    description: 'Jurisdiction subdivision name for CA_NS',
  },
  CA_NT: {
    defaultMessage: 'Northwest Territories',
    id: 'e2bv08Hzl1',
    description: 'Jurisdiction subdivision name for CA_NT',
  },
  CA_NU: {
    defaultMessage: 'Nunavut',
    id: 'vcVPjtrgAS',
    description: 'Jurisdiction subdivision name for CA_NU',
  },
  CA_ON: {
    defaultMessage: 'Ontario',
    id: 'Zjx64eTf4X',
    description: 'Jurisdiction subdivision name for CA_ON',
  },
  CA_PE: {
    defaultMessage: 'Prince Edward Island',
    id: 'EfkIYB8h+6',
    description: 'Jurisdiction subdivision name for CA_PE',
  },
  CA_QC: {
    defaultMessage: 'Quebec',
    id: 'tCydGfYZ0g',
    description: 'Jurisdiction subdivision name for CA_QC',
  },
  CA_SK: {
    defaultMessage: 'Saskatchewan',
    id: 'pUWfDbe9iP',
    description: 'Jurisdiction subdivision name for CA_SK',
  },
  CA_YT: {
    defaultMessage: 'Yukon',
    id: 'HHxTRN+7AB',
    description: 'Jurisdiction subdivision name for CA_YT',
  },
  FR_20R: {
    defaultMessage: 'Corse',
    id: 'cc0YkhohE1',
    description: 'Jurisdiction subdivision name for FR_20R',
  },
  FR_69M: {
    defaultMessage: 'Métropole de Lyon',
    id: 'nzD5ZfvpnV',
    description: 'Jurisdiction subdivision name for FR_69M',
  },
  FR_6AE: {
    defaultMessage: 'Alsace',
    id: 'gSFcjNGnE4',
    description: 'Jurisdiction subdivision name for FR_6AE',
  },
  FR_75C: {
    defaultMessage: 'Paris',
    id: 'VJsxFf0ate',
    description: 'Jurisdiction subdivision name for FR_75C',
  },
  FR_971: {
    defaultMessage: 'Guadeloupe',
    id: 'gDOK8cORYF',
    description: 'Jurisdiction subdivision name for FR_971',
  },
  FR_972: {
    defaultMessage: 'Martinique',
    id: 'wOh1+/YD6w',
    description: 'Jurisdiction subdivision name for FR_972',
  },
  FR_973: {
    defaultMessage: 'Guyane (française)',
    id: 'thqursWxJA',
    description: 'Jurisdiction subdivision name for FR_973',
  },
  FR_974: {
    defaultMessage: 'La Réunion',
    id: '5wHxPGbZx5',
    description: 'Jurisdiction subdivision name for FR_974',
  },
  FR_976: {
    defaultMessage: 'Mayotte',
    id: '6jW+ypI+XW',
    description: 'Jurisdiction subdivision name for FR_976',
  },
  FR_ARA: {
    defaultMessage: 'Auvergne-Rhône-Alpes',
    id: 'DAnsYQqzeQ',
    description: 'Jurisdiction subdivision name for FR_ARA',
  },
  FR_BFC: {
    defaultMessage: 'Bourgogne-Franche-Comté',
    id: 'pvDnxta1Vl',
    description: 'Jurisdiction subdivision name for FR_BFC',
  },
  FR_BRE: {
    defaultMessage: 'Bretagne',
    id: 'j0iIIL+iwQ',
    description: 'Jurisdiction subdivision name for FR_BRE',
  },
  FR_CVL: {
    defaultMessage: 'Centre-Val de Loire',
    id: '09c78HyuDw',
    description: 'Jurisdiction subdivision name for FR_CVL',
  },
  FR_GES: {
    defaultMessage: 'Grand-Est',
    id: 'm4Xa8wU+0o',
    description: 'Jurisdiction subdivision name for FR_GES',
  },
  FR_HDF: {
    defaultMessage: 'Hauts-de-France',
    id: 'hiokWI0S2N',
    description: 'Jurisdiction subdivision name for FR_HDF',
  },
  FR_IDF: {
    defaultMessage: 'Île-de-France',
    id: 'cYo9idiBO1',
    description: 'Jurisdiction subdivision name for FR_IDF',
  },
  FR_NAQ: {
    defaultMessage: 'Nouvelle-Aquitaine',
    id: 'KXHPrBez6e',
    description: 'Jurisdiction subdivision name for FR_NAQ',
  },
  FR_NOR: {
    defaultMessage: 'Normandie',
    id: 'UyfYTX6Uch',
    description: 'Jurisdiction subdivision name for FR_NOR',
  },
  FR_OCC: {
    defaultMessage: 'Occitanie',
    id: 'sHNmXFzhYD',
    description: 'Jurisdiction subdivision name for FR_OCC',
  },
  FR_PAC: {
    defaultMessage: 'Provence-Alpes-Côte-d’Azur',
    id: '4xAceCc8/v',
    description: 'Jurisdiction subdivision name for FR_PAC',
  },
  FR_PDL: {
    defaultMessage: 'Pays-de-la-Loire',
    id: 'uY4Ur31X/s',
    description: 'Jurisdiction subdivision name for FR_PDL',
  },
});

export type JurisdictionMessageKey = keyof typeof jurisdictionMessages;
